<template>
  <pagefra>
    <div class="index">
      <!--
      <div
        class="advert-banner"
        v-if="bannerAdverts.length > 0 && advertIndex < bannerAdverts.length"
      >
        <div class="advert-box" @click="handleAdvertClick">
          <img class="advert-img" :src="bannerAdverts[advertIndex].image" />
          <i class="el-icon-close advert-close" @click.stop="closeAdvert"></i>
        </div>
      </div>
      -->
      <el-dialog
        :visible.sync="advertPopVisible"
        width="600px"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
        custom-class="advert-pop-dialog"
        class="advert-pop"
      >
        <div
          class="advert-pop-body"
          v-if="popAdverts.length > 0 && advertPopIndex < popAdverts.length"
        >
          <img
            class="advert-pop-img"
            :src="popAdverts[advertPopIndex].image"
            @click="handlePopAdvertClick"
          />
          <div class="advert-pop-close" @click="closePopAdvert">
            <i class="el-icon-close"></i>
          </div>
        </div>
      </el-dialog>
      <!-- <div
        class="banner-carousel-wrap"
        v-if="bannerList.length > 0 && bannerVisible"
      >
        <el-carousel
          class="banner-carousel"
          height="300px"
          :interval="4000"
          arrow="always"
          indicator-position="inside"
        >
          <el-carousel-item v-for="item in bannerList" :key="item.id">
            <img class="banner-img" :src="item.image" alt="" />
          </el-carousel-item>
        </el-carousel>
        <i
          class="el-icon-close banner-close"
          title="关闭轮播"
          @click="bannerVisible = false"
        ></i>
      </div> -->
      <el-row
        type="flex"
        justify="space-between"
        :gutter="basePadding"
        v-loading.fullscreen.lock="fullLoading"
        element-loading-background="rgba(0, 0, 0, 0.1)"
      >
        <el-col :span="16">
          <el-row
            type="flex"
            justify="space-between"
            :gutter="basePadding"
            class="index-pie"
            v-loading.fullscreen.lock="fullLoading"
            element-loading-background="rgba(0, 0, 0, 0.1)"
          >
            <el-col :span="12">
              <!-- <panel
            type="gray"
            :title="$t('RemoteStatus')"
            icon="monitor"
            :tips="'当前总共有 ' + sumDeviceCount + ' 台设备'"
            v-loading.lock="deviceMonitorLoading"
            v-if="hasIndexPermission('遥监设备状态')"
          >
            <chartsPie
              ref="deviceChart"
              id="charts-pie-index-device"
              :data="deviceData"
              type="Chart2"
            ></chartsPie>
            <a @click="viewDetailNum(3)" class="viewDetailNum"
              >详细工号请点击</a
            >
          </panel> -->
              <panel
                type="gray"
                :title="$l('运行次数分布')"
                icon="lift2"
                link
                @link-to="openList(4)"
                class="index-breakdown panel--chart"
                v-loading.lock="deviceMonitorLoading"
                v-if="hasIndexPermission('运行次数分布')"
              >
                <div class="run-line">
                  <div class="line1">
                    <h4>{{ $l("0-50万次") }}</h4>
                    <p>
                      {{ runTimesData[5].value }}<small>{{ $l("台") }}</small>
                    </p>
                  </div>
                  <div class="line2">
                    <h4>{{ $l("50-100万次") }}</h4>
                    <p>
                      {{ runTimesData[4].value }}<small>{{ $l("台") }}</small>
                    </p>
                  </div>
                  <div class="line3">
                    <h4>{{ $l("100-150万次") }}</h4>
                    <p>
                      {{ runTimesData[3].value }}<small>{{ $l("台") }}</small>
                    </p>
                  </div>
                  <div class="line4">
                    <h4>{{ $l("150-200万次") }}</h4>
                    <p>
                      {{ runTimesData[0].value }}<small>{{ $l("台") }}</small>
                    </p>
                  </div>
                  <div class="line5">
                    <h4>{{ $l("200万次以上") }}</h4>
                    <p>
                      {{ runTimesData[1].value }}<small>{{ $l("台") }}</small>
                    </p>
                  </div>
                  <div class="line6">
                    <h4>{{ $l("未知") }}</h4>
                    <p>
                      {{ runTimesData[2].value }}<small>{{ $l("台") }}</small>
                    </p>
                  </div>
                </div>
                <chartsPie
                  ref="runTimesChart"
                  id="charts-pie-index-device"
                  :data="runTimesData"
                  type="Chart5"
                ></chartsPie>
              </panel>
              <panel
                type="gray"
                :title="$l('运行次数分布')"
                icon="lift2"
                v-else
              >
                <tipsMask :text="$l('暂无权限')" bgColor="#e3e7ec"></tipsMask>
              </panel>
            </el-col>
            <el-col :span="12">
              <!-- <panel
            type="gray"
            :title="$t('ElevatorStatus')"
            icon="lift2"
            v-loading.lock="elevatorStatusLoading"
            v-if="hasIndexPermission('电梯状态')"
          >
            <chartsPie
              ref="liftChart"
              id="charts-pie-index-state"
              :data="liftData"
              type="Chart1"
            ></chartsPie>
            <a @click="viewDetailNum(1)" class="viewDetailNum"
              >详细工号请点击</a
            >
          </panel> -->
              <panel
                type="gray"
                :title="$l('今日救援进度统计')"
                icon="lift2"
                v-loading.lock="elevatorStatusLoading"
                v-if="hasIndexPermission('今日救援进度统计')"
              >
                <div class="rescue-view">
                  <div class="rescue-items maintain">
                    <div class="tip tip-plus">
                      <p>{{ $l("故障维修进度") }}</p>
                    </div>
                    <div class="progress-box">
                      <div
                        class="bar-box"
                        v-for="(item, index) in rescueProgress.maintain.number"
                        :key="index"
                      >
                        <div class="progress-bar" @click="openAlarm(1, index)">
                          <screen-circle
                            :config="circleConfig1"
                            :rate="rescueProgress.maintain.progress[index]"
                          >
                            <div v-if="index == 0" class="progress-bar-icon">
                              <svgicon name="repair" />
                            </div>
                            <span v-else>{{
                              rescueProgress.maintain.progress[index]
                                | progressDecimals
                            }}</span>
                          </screen-circle>
                        </div>
                        <!-- <div class="decorate"></div> -->
                        <div class="text">
                          {{ $l(progressText[index]) }}
                          <em>{{ item }}</em>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="rescue-items rescue">
                    <div class="tip tip-plus">
                      <p>{{ $l("困人救援进度") }}</p>
                    </div>
                    <div class="progress-box">
                      <div
                        class="bar-box"
                        v-for="(item, index) in rescueProgress.rescue.number"
                        :key="index"
                      >
                        <div class="progress-bar" @click="openAlarm(2, index)">
                          <screen-circle
                            :config="circleConfig2"
                            :rate="rescueProgress.rescue.progress[index]"
                          >
                            <div v-if="index == 0" class="progress-bar-icon">
                              <svgicon name="briefcase" />
                            </div>
                            <span v-else>{{
                              rescueProgress.rescue.progress[index]
                                | progressDecimals
                            }}</span>
                          </screen-circle>
                        </div>
                        <!-- <div class="decorate"></div> -->
                        <div class="text">
                          {{ $l(progressText2[index]) }}
                          <em>{{ item }}</em>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </panel>
              <panel
                type="gray"
                :title="$l('今日救援进度统计')"
                icon="lift2"
                v-else
              >
                <tipsMask :text="$l('暂无权限')" bgColor="#e3e7ec"></tipsMask>
              </panel>
            </el-col>
          </el-row>

          <el-row type="flex" :gutter="basePadding">
            <el-col :span="12">
              <panel
                type="gray"
                :title="$l('实时关注信息')"
                icon="bell"
                tools
                height="272px"
                v-loading.lock="realFollowLoading"
              >
                <vue-seamless-scroll
                  :data="scrollList"
                  :class-option="classOption"
                  class="autoscroll-content"
                >
                  <ul class="noticeList noticeList--card">
                    <!-- <li>
                      <div class="state-success">
                        <h5>
                          速度啊水电<em>啊水电啊的</em>速度啊水电速度啊水电速度啊水电
                        </h5>
                        <span>261892123341 一宗故障停梯消除</span>
                      </div>
                    </li>
                    <li>
                      <div class="state-primary">
                        <h5>速度啊水电<em>啊水电啊的</em></h5>
                        <span>261892123341 一宗故障停梯消除</span>
                      </div>
                    </li> -->

                    <li v-for="(item, index) in scrollList" :key="index">
                      <div
                        :class="item.remove ? 'state-success' : 'state-primary'"
                        v-if="item.type == 1"
                      >
                        <h5>
                          {{ item.city | defaultValue }}
                          <em
                            >{{ item.domainName | defaultValue }}
                            {{ $l("电梯") }}</em
                          >
                          {{ item.jobNum }} {{ $l("于") }}
                          {{ item.time }}
                          <em>{{
                            item.remove
                              ? $l("一宗故障停梯消除")
                              : $l("发生故障停梯")
                          }}</em>
                        </h5>
                        <span>
                          {{ item.updateTime }}&emsp;{{
                            item.remove
                              ? $l("一宗故障停梯消除")
                              : $l("发生故障停梯")
                          }}
                        </span>
                      </div>
                      <div
                        :class="item.remove ? 'state-success' : 'state-primary'"
                        v-if="item.type == 2"
                      >
                        <h5>
                          {{ item.city | defaultValue }}
                          <em>{{ item.domainName | defaultValue }} 电梯</em>
                          {{ item.jobNum }} 于 {{ item.time }}
                          <em>{{
                            item.remove ? $l("完成困人救援") : $l("发生困人")
                          }}</em>
                        </h5>
                        <span>
                          {{ item.updateTime }}&emsp;{{
                            item.remove ? $l("完成困人救援") : $l("发生困人")
                          }}
                        </span>
                      </div>
                      <!-- <div
                    :class="item.remove ? 'state-success' : 'state-warning'"
                    v-if="item.type == 3"
                  >
                    <h5>
                      {{ item.city | defaultValue }}
                      <em>{{ item.domainName | defaultValue }} 电梯</em>
                      {{ item.jobNum }} 于 {{ item.time }}
                      <em>遥监设备{{ item.remove ? "恢复正常" : "掉线" }}</em>
                    </h5>
                    <span>
                      {{ item.updateTime }}&emsp;设备{{
                        item.remove ? "恢复正常" : "掉线"
                      }}
                    </span>
                  </div> -->
                    </li>
                    <li v-if="scrollList.length == 0" class="emptydata">
                      <span>{{ $l("暂无数据") }} </span>
                    </li>
                  </ul>
                  <br />
                </vue-seamless-scroll>
                <tipsMask
                  :text="$l('暂无权限')"
                  bgColor="#e3e7ec"
                  v-if="!hasIndexPermission('今日实时关注信息')"
                ></tipsMask>
              </panel>
            </el-col>
            <el-col :span="12">
              <panel
                type="gray"
                :title="$l('梯龄分布')"
                icon="lift2"
                tools
                height="272px"
                class="panel--chart"
                v-loading.lock="elevatorAgeLoading"
              >
                <chartsBar
                  ref="liftAgeChart"
                  id="charts-bar-index"
                  :data="ageBar"
                ></chartsBar>
                <tipsMask
                  :text="$l('暂无权限')"
                  bgColor="#e3e7ec"
                  v-if="!hasIndexPermission('梯龄分布')"
                ></tipsMask>
              </panel>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="8" class="ub ub-v">
          <!-- <panel
            type="gray"
            :title="$t('MaintenanceMonth')"
            icon="wrench"
            v-loading.lock="mainFinishLoading"
            v-if="hasIndexPermission('今月保养完成情况')"
          >
            <chartsProgress
              id="charts-progress"
              :data="repairData"
            ></chartsProgress>
            <a @click="viewDetailNum(2)" class="viewDetailNum"
              >详细工号请点击</a
            >
          </panel> -->
          <panel
            type="colorful"
            height="100%"
            :title="$l('无纸化保养记录')"
            icon="wrench"
            v-loading.lock="mainFinishLoading"
            v-if="hasIndexPermission('无纸化保养记录')"
          >
            <template slot="title-r">
              <div class="select-date">
                <span class="left" @click="changeDate(0)"
                  ><i class="el-icon-arrow-left"></i
                ></span>
                <span class="month"
                  >{{ calenderDate.y + "-" + calenderDate.m
                  }}<i class="el-icon-caret-bottom"></i>
                  <el-date-picker
                    prefix-icon="none"
                    :clearable="false"
                    class="custom-date-picker"
                    v-model="datePickerValue"
                    type="month"
                    @change="changeCalenderDate"
                  >
                  </el-date-picker
                ></span>
                <span class="right" @click="changeDate(1)"
                  ><i class="el-icon-arrow-right"></i
                ></span>
              </div>
            </template>
            <div class="main-record">
              <div class="title">
                <div
                  class="title-text"
                  v-for="item in calendarTitle"
                  :key="item"
                >
                  {{ $l(item) }}
                </div>
              </div>
              <div class="content">
                <div
                  class="item"
                  v-for="(item, index) in calenderDate.ds"
                  :key="index"
                  :class="[
                    calcBeforeDate(item.date, calenderDate.activateDate)
                      ? 'activate'
                      : '',
                  ]"
                >
                  <span class="item-day">{{ item.d }}</span>
                  <span
                    v-if="
                      item.planOrFinish[0] === 0 && item.planOrFinish[1] === 0
                    "
                    class="item-not-plan"
                    >暂无计划</span
                  >
                  <div v-else>
                    <span
                      class="item-plan"
                      @click="openMaintain(1, item.date)"
                      >{{ item.planOrFinish[1] }}</span
                    >
                    <span
                      class="item-finish"
                      @click="openMaintain(2, item.date)"
                      >{{ item.planOrFinish[0] }}</span
                    >
                  </div>
                </div>
              </div>
            </div>

            <div class="legend">
              <span class="plan"
                >{{ $l("未完成") }}<em>{{ totalUnfinished }}</em></span
              >
              <span class="finish"
                >{{ $l("已完成") }}<em>{{ totalFinished }}</em></span
              >
            </div>
          </panel>
          <panel
            type="gray"
            class="ub-flex"
            :title="$l('无纸化保养记录')"
            icon="wrench"
            v-else
          >
            <tipsMask :text="$l('暂无权限')" bgColor="#e3e7ec"></tipsMask>
          </panel>
        </el-col>
      </el-row>
      <!-- v-if="hasPermissionByName('maintainManage')" -->
      <el-row type="flex" :gutter="basePadding">
        <el-col :span="8">
          <!-- title="年检提醒" -->
          <panel
            :title="$l('年检提醒')"
            icon="nianjian"
            tools
            link
            @link-to="openList(1)"
            height="292px"
            v-loading.lock="yearCheckLoading"
            v-if="hasIndexPermission('年检提醒')"
          >
            <el-select
              v-model="yearCheckTime"
              :placeholder="$l('请选择')"
              class="select-light"
              slot="tools"
              @change="yearCheckChange"
            >
              <el-option :label="$l('1个月内')" value="1"></el-option>
              <el-option :label="$l('3个月内')" value="3"></el-option>
              <el-option :label="$l('6个月内')" value="6"></el-option>
            </el-select>
            <ul class="noticeList">
              <li v-for="(item, index) in annualAlarm" :key="index">
                <div>
                  <p :title="item.domainName">
                    <small
                      >{{ item.city | defaultValue
                      }}<span class="se">|</span></small
                    >{{ item.domainName | defaultValue }}
                  </p>
                  <!-- <span>
                    电梯距离
                    <b>{{ item.deadline }}</b>年检日
                  </span> -->
                </div>
                <span @click="openList(1, item.domainId, item.city)">
                  <em style="cursor: pointer">{{ item.utils }}</em
                  >{{ $l("台") }}
                </span>
              </li>
            </ul>
            <div v-if="annualAlarm.length == 0" class="emptydata">
              <span>{{ $l("没有年检提醒数据") }} </span>
            </div>
          </panel>
          <panel :title="$l('年检提醒')" icon="bell" height="272px" v-else>
            <tipsMask :text="$l('暂无权限')" bgColor="#e3e7ec"></tipsMask>
          </panel>
        </el-col>
        <el-col :span="8">
          <panel
            :title="$l('合同提醒')"
            icon="contract"
            tools
            height="292px"
            link
            @link-to="openList(2)"
            v-loading.lock="contractLoading"
            v-if="hasIndexPermission('合同提醒')"
          >
            <el-select
              v-model="contractCheckTime"
              :placeholder="$l('请选择')"
              class="select-light"
              slot="tools"
              @change="contractCheckChange"
            >
              <el-option :label="$l('3个月内')" value="3"></el-option>
              <el-option :label="$l('6个月内')" value="6"></el-option>
              <el-option :label="$l('12个月内')" value="12"></el-option>
            </el-select>
            <ul class="noticeList">
              <li v-for="(item, index) in contractAlarm" :key="index">
                <div>
                  <p>{{ item.id }}</p>
                  <span
                    >{{ item.city | defaultValue }} ·
                    {{ item.domainName | defaultValue }} · {{ $l("电梯") }}

                    {{ item.utils }} {{ $l("台") }}
                  </span>
                </div>
                <span @click="openList(2, item.id, null, item.endDate)">
                  <em style="cursor: pointer">{{ item.days }}</em
                  >{{ $l("天") }}
                </span>
              </li>
            </ul>
            <div v-if="contractAlarm.length == 0" class="emptydata">
              <span>{{ $l("没有合同提醒数据") }} </span>
            </div>
          </panel>
          <panel :title="$l('合同提醒')" icon="bell" height="292px" v-else>
            <tipsMask :text="$l('暂无权限')" bgColor="#e3e7ec"></tipsMask>
          </panel>
        </el-col>
        <el-col :span="8">
          <panel
            :title="$l('昨日遥监预警记录汇总')"
            icon="alarm"
            height="292px"
            link
            @link-to="openList(3)"
            class="index-breakdown"
            v-loading.lock="yesterdayFaultLoading"
            v-if="hasIndexPermission('昨日遥监预警记录汇总')"
          >
            <ul class="noticeList noticeList--rank">
              <li
                v-for="(item, index) in breakdownLift.slice(0, 3)"
                :key="index"
              >
                <h4>{{ index + 1 }}</h4>
                <div>
                  <span
                    >{{ item.city | defaultValue }} · {{ $l("故障台量") }}
                    {{ item.liftCount }}{{ $l("台") }}
                  </span>
                  <p>{{ item.domainName | defaultValue }}</p>
                </div>
                <span @click="openList(3, item.domainId)">
                  <em style="cursor: pointer">{{ item.faultCount }}</em
                  >{{ $l("宗") }}
                </span>
              </li>
            </ul>
            <div v-if="breakdownLift.length == 0" class="emptydata">
              <span>{{ $l("没有昨日遥监预警记录汇总数据") }} </span>
            </div>
          </panel>
          <panel :title="$l('昨日遥监预警记录汇总')" height="292px" v-else>
            <tipsMask :text="$l('暂无权限')" bgColor="#e3e7ec"></tipsMask>
          </panel>
        </el-col>
        <!-- <el-col :span="16">
          <panel
            :title="stopLiftTitle"
            tools
            link
            @link-to="openList(4)"
            height="272px"
            v-loading.lock="sevenDayFaultLoading"
            v-if="hasIndexPermission('近7天故障停梯故障趋势')"
          >
            <el-radio-group
              v-model="breakdownDateCheck"
              size="small"
              class="tabs-tag"
              slot="tools"
              @change="stopLiftDaysChange"
            >
              <el-radio-button label="7">7天</el-radio-button>
              <el-radio-button label="15">15天</el-radio-button>
            </el-radio-group>
            <chartsPoly
              id="charts-poly-index"
              :data="breakdownPoly"
              :days="breakdownDateCheck"
              @itemClick="polyItemClick"
            ></chartsPoly>
          </panel>
          <panel :title="stopLiftTitle" height="272px" v-else>
            <tipsMask text="暂无权限" bgColor="#e3e7ec"></tipsMask>
          </panel>
        </el-col> -->
      </el-row>

      <!-- <el-row type="flex" :gutter="basePadding">
        <el-col :span="8">
          <panel
            :title="$t('YestodayMonitoring')"
            height="292px"
            link
            @link-to="openList(3)"
            class="index-breakdown"
            v-loading.lock="yesterdayFaultLoading"
            v-if="hasIndexPermission('昨日遥监预警记录汇总')"
          >
            <el-row type="flex" :gutter="40">
              <el-col :lg="10" :md="12">
                <ul class="noticeList noticeList--rank">
                  <li
                    v-for="(item, index) in breakdownLift.slice(0, 3)"
                    :key="index"
                  >
                    <h4>{{ index + 1 }}</h4>
                    <div>
                      <span
                        >{{ item.city | defaultValue }} · 故障台量{{
                          item.liftCount
                        }}台</span
                      >
                      <p>{{ item.domainName | defaultValue }}</p>
                    </div>
                    <span @click="openList(3, item.domainId)">
                      <em style="cursor: pointer">{{ item.faultCount }}</em
                      >宗
                    </span>
                  </li>
                </ul>
              </el-col>
              <el-col :lg="14" :md="12">
                <ul class="noticeList">
                  <li
                    v-for="(item, index) in breakdownLift.slice(3)"
                    :key="index"
                  >
                    <h4>{{ index + 4 }}</h4>
                    <div>
                      <span
                        >{{ item.city | defaultValue }} · 故障台量{{
                          item.liftCount
                        }}台</span
                      >
                      <p>{{ item.domainName | defaultValue }}</p>
                    </div>
                    <span @click="openList(3, item.domainId)">
                      <em style="cursor: pointer">{{ item.faultCount }}</em
                      >宗
                    </span>
                  </li>
                </ul>
              </el-col>
            </el-row>
            <div v-if="breakdownLift.length == 0" class="emptydata">
              <span>没有昨日遥监预警记录汇总数据</span>
            </div>
          </panel>
          <panel title="昨日遥监预警记录汇总" height="292px" v-else>
            <tipsMask text="暂无权限" bgColor="#e3e7ec"></tipsMask>
          </panel>
        </el-col>
      </el-row> -->

      <el-dialog
        :title="$l(listDialogTitle)"
        :visible.sync="listDialogVisible"
        width="900px"
      >
        <panel>
          <el-table
            ref="singleTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            v-loading.lock="listLoading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            v-if="listType == 1"
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              property="city"
              :label="$l('城市')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="domainName"
              :label="$l('地盘')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="buildingName"
              :label="$l('大楼名称')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="elevatorNum"
              :label="$l('梯号')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="jobNum"
              :label="$l('工号')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="elevatorAge"
              :label="$l('梯龄')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="registerCode"
              :label="$l('注册代码')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="inspectDate"
              :label="$l('年检日期')"
              min-width="200"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="days"
              :label="$l('剩余天数')"
              min-width="120"
              header-align="center"
              align="center"
              sortable
            >
            </el-table-column>
          </el-table>
          <el-table
            ref="singleTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            v-loading.lock="listLoading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            v-else-if="listType == 2"
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              property="agreeNum"
              :label="$l('合同号')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="city"
              :label="$l('城市')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="domainName"
              :label="$l('地盘')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="assetNum"
              :label="$l('工号')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="endDate"
              :label="$l('到期日期')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="days"
              :label="$l('剩余天数')"
              min-width="120"
              header-align="center"
              align="center"
              sortable
            >
            </el-table-column>
          </el-table>
          <el-table
            ref="singleTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            v-loading.lock="listLoading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            v-else-if="listType == 4"
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              property="city"
              :label="$l('城市')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="domainName"
              :label="$l('地盘')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="buildingName"
              :label="$l('大楼名称')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="elevatorNum"
              :label="$l('梯号')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="jobNum"
              :label="$l('工号')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="elevatorAge"
              :label="$l('梯龄')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="registerCode"
              :label="$l('注册代码')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="runTimesOr"
              :label="$l('运行次数')"
              min-width="120"
              header-align="center"
              align="center"
              sortable
            >
            </el-table-column>
          </el-table>
          <el-table
            ref="singleTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            v-loading.lock="listLoading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            v-else
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              property="city"
              :label="$l('城市')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="domainName"
              :label="$l('地盘')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="buildingName"
              :label="$l('大楼名称')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="elevatorNum"
              :label="$l('梯号')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="jobNum"
              :label="$l('工号')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="elevatorAge"
              :label="$l('梯龄')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="registerCode"
              :label="$l('注册代码')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="faultCount"
              :label="$l('故障数')"
              min-width="120"
              header-align="center"
              align="center"
              sortable
            ></el-table-column>
          </el-table>
          <el-pagination
            :current-page="pageConfig.currentPage"
            :page-sizes="pageConfig.pageSizes"
            :page-size="pageConfig.pageSize"
            :total="pageConfig.total"
            @size-change="handlePageSizeChange"
            @current-change="handleCurrentPageChange"
            layout="total, sizes, prev, pager, next, jumper"
          ></el-pagination>
        </panel>

        <div
          style="text-align: right; position: relative; top: 0px"
          v-if="
            listType == 1 || listType == 2 || listType == 3 || listType == 4
          "
        >
          <el-button round icon="el-icon-download" @click="exportData()"
            >{{ $l("导出") }}
          </el-button>
        </div>
      </el-dialog>
      <el-dialog
        :title="$l('查看电梯工号')"
        :visible.sync="jobNumListDialogVisible"
        width="900px"
      >
        <el-form :inline="true" :model="jobNumForm">
          <el-form-item v-if="jobNumListType == 1">
            <el-select
              v-model="jobNumForm.elevatorStatus"
              :placeholder="$l('电梯状态')"
            >
              <el-option :label="$l('电梯状态')" value="-1"></el-option>
              <el-option
                v-for="item in elevatorStatusArr"
                :key="item.type"
                :label="$l(item.text)"
                :value="item.type"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" v-if="jobNumListType == 2">
            <el-select
              v-model="jobNumForm.planStatus"
              :placeholder="$l('作业状态')"
            >
              <el-option :label="$l('作业状态')" value=""></el-option>
              <el-option value="已计划">{{ $l("已计划") }} </el-option>
              <el-option value="已完成"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" v-if="jobNumListType == 3">
            <el-select
              v-model="jobNumForm.monitorStatus"
              :placeholder="$l('遥监状态')"
            >
              <el-option :label="$l('遥监状态')" value="-1"></el-option>
              <el-option
                v-for="item in monitorStatusArr"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              type="primary"
              circle
              @click="search"
            ></el-button>
          </el-form-item>
        </el-form>
        <panel>
          <el-table
            ref="singleTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            v-loading.lock="jobNumListLoading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              property="city"
              :label="$l('城市')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="domainName"
              :label="$l('地盘')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="buildingName"
              :label="$l('大楼名称')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="elevatorNum"
              :label="$l('梯号')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="assetId"
              :label="$l('工号')"
              min-width="150"
              header-align="center"
              align="center"
              v-if="jobNumListType == 2"
            ></el-table-column>
            <el-table-column
              property="jobNum"
              :label="$l('工号')"
              min-width="150"
              header-align="center"
              align="center"
              v-else
            >
            </el-table-column>
            <el-table-column
              property="elevatorAge"
              :label="$l('梯龄')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="registerCode"
              :label="$l('注册代码')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              :label="$l('电梯状态')"
              prop="elevatorStatus"
              align="center"
              min-width="150"
              :formatter="elevatorStatusFormatter"
              v-if="jobNumListType == 1"
            >
            </el-table-column>
            <el-table-column
              :label="$l('遥监状态')"
              prop="isactive"
              align="center"
              min-width="150"
              :formatter="monitorStatusFormatter"
              v-if="jobNumListType == 3"
            ></el-table-column>
            <el-table-column
              :label="$l('作业状态')"
              prop="planStatus"
              align="center"
              min-width="150"
              v-if="jobNumListType == 2"
            >
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page="pageConfig.currentPage"
            :page-sizes="pageConfig.pageSizes"
            :page-size="pageConfig.pageSize"
            :total="pageConfig.total"
            @size-change="handlePageSizeChange"
            @current-change="handleCurrentPageChange"
            layout="total, sizes, prev, pager, next, jumper"
          ></el-pagination>
        </panel>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import chartsPoly from "@/components/chartsPoly.vue";
import chartsPie from "@/components/chartsPie.vue";
import chartsBar from "@/components/chartsBar.vue";
import chartsProgress from "@/components/chartsProgress.vue";
import tipsMask from "@/components/tipsMask.vue";
import screenCircle from "../components/screenCircle.vue";
import global from "@/mixins/global.js";
import dayjs from "dayjs";

export default {
  name: "index",
  mixins: [global],
  components: {
    panel,
    chartsPoly,
    chartsPie,
    chartsProgress,
    chartsBar,
    tipsMask,
    screenCircle,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      liftData: [
        // { name: "正常运行", value: 0, type: "1" },
        // { name: "维修保养", value: 0, type: "3" },
        // { name: "故障停梯", value: 0, type: "4" },
        // { name: "其它", value: 0, type: "0" },
        { name: "故障停梯", value: 0, type: "0" },
        { name: "电梯困人", value: 0, type: "1" },
        { name: "正常运行", value: 0, type: "2" },
      ],
      repairData: {
        sum: 0,
        value: 0,
      },
      circleConfig1: {
        borderWidth: "0.2vw",
        circleSize: "0",
        startColor: "#545E6D",
        endColor: "#545E6D",
        centerCircleBg: "#fff",
        borderBackground: "#D5D8DD",
      },
      circleConfig2: {
        borderWidth: "0.2vw",
        circleSize: "0",
        startColor: "#EC102D",
        endColor: "#EC102D",
        centerCircleBg: "#fff",
        borderBackground: "#F0D3D7",
      },
      rescueProgress: {
        maintain: {
          number: [0, 0, 0, 0],
          progress: [0, 0, 0, 0],
        },
        rescue: {
          number: [0, 0, 0, 0],
          progress: [0, 0, 0, 0],
        },
      },
      deviceData: [
        { name: "正常监视", value: 0, type: "1" },
        // { name: "曾正常监视", value: 0, type: "2" },
        { name: "未正常监视", value: 0, type: "0" },
        // { name: "其它", value: 0, type: "3" },
      ],
      runTimesData: [
        { name: "150-200万次", value: 0, type: "4" },
        { name: "200万次以上", value: 0, type: "5" },
        { name: "未知", value: 0, type: "6" },
        { name: "100-150万次", value: 0, type: "3" },
        { name: "50-100万次", value: 0, type: "2" },
        { name: "0-50万次", value: 0, type: "1" },
      ],
      elevatorStatusArr: [
        // { type: 1, text: "正常运行", value: 0 },
        // { type: 3, text: "维修保养", value: 0 },
        // { type: 4, text: "故障停梯", value: 0 },
        // { type: 0, text: "其它", value: 0 },
        { text: "故障停梯", value: 0, type: "0" },
        { text: "电梯困人", value: 0, type: "1" },
        { text: "正常运行", value: 0, type: "2" },
      ],
      monitorStatusArr: [
        { value: 1, text: "正常监视" },
        // { value: 2, text: "曾正常监视" },
        { value: 0, text: "未正常监视" },
        // { value: 3, text: "其它" },
      ],
      annualAlarm: [],
      contractAlarm: [],
      breakdownPoly: {
        value: [],
        name: [],
      },
      breakdownDateCheck: "7",
      breakdownLift: [],
      ageCategory: [
        this.$l("0~3年"),
        this.$l("3~6年"),
        this.$l("6~10年"),
        this.$l("10~15年"),
        this.$l("15年以上"),
        this.$l("未知"),
      ],
      ageBar: {
        //梯龄分布
        category: [],
        legendShow: false,
        labelShow: true,
        value: [
          {
            name: this.$l("梯龄"),
            data: [],
          },
        ],
      },
      tableData: [],
      stopElevatorCount: 0,
      sumElevatorCount: 0,
      sumDeviceCount: 0,
      elevatorAbnormalCount: 0,
      elevatorStatusLoading: false,
      mainFinishLoading: false,
      deviceMonitorLoading: false,
      yearCheckLoading: false,
      yearCheckTime: "1",
      stopLiftTitle: "近7天故障停梯故障趋势",
      // sevenDayFaultLoading: false,
      elevatorAgeLoading: false,
      contractLoading: false,
      contractCheckTime: "3",
      yesterdayFaultLoading: false,
      listDialogVisible: false,
      listLoading: false,
      listDialogTitle: "",
      listType: 1,
      listUrl: "",
      jobNumListDialogVisible: false,
      jobNumListLoading: false,
      form: {
        pageNum: 1,
        pageSize: 10,
        expiryInterval: 0,
      },
      jobNumForm: {
        elevatorStatus: "-1",
        monitorStatus: "-1",
        planStatus: "",
      },
      count: 0,
      dataListCacheKey: "index_data_list",
      dataTotalCacheKey: "index_data_total",
      dataListObj: {},
      bannerList: [],
      bannerVisible: true,
      advertList: [],
      advertIndex: 0,
      advertPopVisible: false,
      advertPopIndex: 0,
      jobNumListType: 1,
      tableType: 1,
      //今日实时消息滚动
      scrollList: [],
      realFollowLoading: false,
      dataPermissionList: [],
      apiCount: 0, //请求的接口数
      fullLoading: false,
      calenderDate: {
        y: null,
        m: null,
        d: null,
        ds: [],
      },
      calendarTitle: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      datePickerValue: null,
      progressText: ["已报修", "已派工", "已到场", "已完工"],
      progressText2: ["已报修", "已派工", "已到场", "已完工"],
    };
  },
  filters: {
    defaultValue: function (value) {
      if (!value || !value.trim()) {
        return "--";
      }
      if (value.trim().length > 8) {
        return value.substring(0, 8) + "...";
      }
      return value;
    },
    progressDecimals(decimals) {
      return (decimals * 100).toFixed(0) + "%";
    },
  },
  computed: {
    bannerAdverts() {
      return this.advertList.filter((item) => item.popupType == 20);
    },
    popAdverts() {
      return this.advertList.filter((item) => item.popupType == 10);
    },
    dataPermissions() {
      return this.$store.state.dataPermissionList;
    },
    totalUnfinished() {
      return this.calenderDate.ds.reduce((sum, item) => {
        if (item.planOrFinish && item.planOrFinish[1] !== 0) {
          return sum + item.planOrFinish[1];
        }
        return sum;
      }, 0);
    },
    totalFinished() {
      return this.calenderDate.ds.reduce((sum, item) => {
        if (item.planOrFinish) {
          return sum + item.planOrFinish[0];
        }
        return sum;
      }, 0);
    },
    classOption: function () {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 90, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
      };
    },
  },
  watch: {
    dataPermissions(val) {
      if (val[0] != "全部") {
        this.dataPermissionList = val;
      } else {
        this.dataPermissionList = [];
      }

      // if (this.hasIndexPermission("电梯状态")) {
      //   this.statisticsElevatorStatusCount();
      // }
      // if (this.hasIndexPermission("遥监设备状态")) {
      //   this.statisticsMonitorStatusCount();
      // }
      // if (this.hasIndexPermission("今月保养完成情况")) {
      //   this.statisticsMainPlanStatusCount();
      // }
      // if (this.hasIndexPermission("近7天故障停梯故障趋势")) {
      //   this.statisticsOneWeekStopFaultCount(7);
      // }
      if (this.hasIndexPermission("今日救援进度统计")) {
        this.getRescueProgressData();
      }
      if (this.hasIndexPermission("无纸化保养记录")) {
        this.getDateMaintainRecordDate();
      }
      if (this.hasIndexPermission("运行次数分布")) {
        this.getElevatorRunTimesDistribute();
      }
      if (this.hasIndexPermission("年检提醒")) {
        this.searchMainPlanExpireCount();
      }
      if (this.hasIndexPermission("梯龄分布")) {
        this.statisticsElevatorAgeCount();
      }
      if (this.hasIndexPermission("合同提醒")) {
        this.searchAgreementExpire();
      }
      if (this.hasIndexPermission("昨日遥监预警记录汇总")) {
        this.statisticsYesterdayStopFaultCount();
      }
      if (this.hasIndexPermission("今日实时关注信息")) {
        if (this.$store.state.indexRealTimer) {
          window.clearTimeout(this.$store.state.indexRealTimer);
          this.$store.state.indexRealTimer = null;
        }
        this.searchRealElevatorFault();
      }
    },
  },
  mounted() {
    // this.$store.state.indexLiftStatusTimer = null;
    // this.$store.state.indexDeviceStatusTimer = null;
    this.$store.state.indexRealTimer = null;
    this.$store.state.checkIndexRealTimer = null;
    if (this.loaded) {
      this.initData();
      // this.getBannerList();
      this.getAdvertList();
      // this.$http
      //   .get(
      //     this.$apiConfig.get_role_index_permission_url +
      //       this.$store.state.user.roleId
      //   )
      //   .then((response) => {
      //     let result = response.data;
      //     if (result.code == 0) {
      //       let data = result.data;
      //       this.$store.state.indexPermissions = data;
      //       sessionStorage.setItem("indexPermissions", JSON.stringify(data));
      //       this.$store.state.isLoadIndexPermissions = true;
      //       this.initData();
      //     }else{
      //       this.$store.state.isLoadIndexPermissions = true;
      //     }
      //   })
      //   .catch((error) => {
      //     this.$store.state.isLoadIndexPermissions = true;
      //     this.$sentry.captureException(error);
      //   });
    }
  },
  beforeRouteLeave(to, from, next) {
    this.closeTimer();
    next();
  },
  beforeDestroy() {
    this.closeTimer();
    if (
      this.$store.state.checkIndexRealTimer &&
      this.$store.state.checkIndexRealTimer != -1
    ) {
      window.clearInterval(this.$store.state.checkIndexRealTimer);
    }
    this.$store.state.checkIndexRealTimer = -1;
  },
  activated() {
    if (
      this.loaded &&
      (!this.$store.state.indexRealTimer ||
        this.$store.state.indexRealTimer == -1)
    ) {
      // this.$store.state.indexLiftStatusTimer = null;
      // this.$store.state.indexDeviceStatusTimer = null;
      this.$store.state.indexRealTimer = null;
      // this.$store.state.checkIndexRealTimer = null;
      // this.startElevatorStatusTimer();
      // this.startMonitorStatusTimer();
      this.$store.state.indexRealTimer = window.setTimeout(() => {
        this.searchRealElevatorFault();
      }, window.config.indexRealTimerInterval);
    }
  },
  methods: {
    getBannerList() {
      this.$http
        .get(this.$apiConfig.get_fd_banner_list_url)
        .then((response) => {
          const result = response.data;
          if (result.code == 0) {
            const list = Array.isArray(result.data) ? result.data : [];
            list.sort((a, b) => (a.sort || 0) - (b.sort || 0));
            this.bannerList = list;
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    getAdvertList() {
      this.$http
        .get(this.$apiConfig.get_fd_advert_list_url)
        .then((response) => {
          const result = response.data;
          if (result.code == 0) {
            this.advertList = Array.isArray(result.data) ? result.data : [];
            this.advertIndex = 0;
            this.advertPopIndex = 0;
            this.advertPopVisible = this.popAdverts.length > 0;
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    // closeAdvert() {
    //   this.advertIndex++;
    // },
    closePopAdvert() {
      this.advertPopIndex++;
      if (this.advertPopIndex >= this.popAdverts.length) {
        this.advertPopVisible = false;
      }
    },
    // handleAdvertClick() {
    //   const item = this.bannerAdverts[this.advertIndex];
    //   if (!item) return;
    //   this.handleAdvertJump(item);
    // },
    handlePopAdvertClick() {
      const item = this.popAdverts[this.advertPopIndex];
      if (!item) return;
      this.handleAdvertJump(item);
    },
    handleAdvertJump(item) {
      if (item.jumpMethod == 30 && item.jumpParameter) {
        window.open(item.jumpParameter);
      }
    },
    closeTimer() {
      // if (
      //   this.$store.state.indexLiftStatusTimer &&
      //   this.$store.state.indexLiftStatusTimer != -1
      // ) {
      //   window.clearInterval(this.$store.state.indexLiftStatusTimer);
      // }
      // this.$store.state.indexLiftStatusTimer = -1;
      // if (
      //   this.$store.state.indexDeviceStatusTimer &&
      //   this.$store.state.indexDeviceStatusTimer != -1
      // ) {
      //   window.clearInterval(this.$store.state.indexDeviceStatusTimer);
      // }
      // this.$store.state.indexDeviceStatusTimer = -1;
      if (
        this.$store.state.indexRealTimer &&
        this.$store.state.indexRealTimer != -1
      ) {
        window.clearTimeout(this.$store.state.indexRealTimer);
      }
      this.$store.state.indexRealTimer = -1;
    },
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      if (this.tableType == 1) {
        this.form.pageSize = val;
        this.loadData(this.listUrl);
      } else {
        this.viewDetailNum(this.jobNumListType);
      }
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      if (this.tableType == 1) {
        this.form.pageNum = val;
        this.loadData(this.listUrl);
      } else {
        this.viewDetailNum(this.jobNumListType);
      }
    },
    linkTo(url) {
      this.$router.push({
        path: url,
      });
    },
    yearCheckChange(val) {
      this.searchMainPlanExpireCount();
    },
    contractCheckChange(val) {
      this.searchAgreementExpire();
    },
    /* 获取今日救援进度 */
    getRescueProgressData() {
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(this.dataListCacheKey);
        if (json) {
          this.count++;
          this.rescueProgress = JSON.parse(json)["rescueProgress"];
          return;
        }
      }
      this.elevatorStatusLoading = true;
      this.$http
        .post(this.$apiConfig.get_elevator_rescue_progress_url)
        .then((response) => {
          this.elevatorStatusLoading = false;
          let result = response.data;
          if (result.code != 0) return this.message(result.code, result.msg);
          let data = result.data;
          const { maintain, rescue, rescueCompleteTime } = data;
          let maintainProgress = [
            1,
            1,
            maintain[0] ? Number((maintain[2] / maintain[0]).toFixed(2)) : 1,
            maintain[0] ? Number((maintain[3] / maintain[0]).toFixed(2)) : 1,
          ];
          let rescueProgress = [
            1,
            1,
            rescue[0] ? Number((rescue[2] / rescue[0]).toFixed(2)) : 1,
            rescue[0] ? Number((rescue[3] / rescue[0]).toFixed(2)) : 1,
          ];
          this.rescueProgress.maintain.number = maintain;
          this.rescueProgress.maintain.progress = maintainProgress;
          this.rescueProgress.rescue.number = rescue;
          this.rescueProgress.rescue.progress = rescueProgress;
          if (rescueCompleteTime) {
            this.progressText2[3] = "已救出";
          } else {
            this.progressText2[3] = "已完工";
          }
          if (
            !this.loaded &&
            this.$store.state.pageScroll.scroll &&
            !sessionStorage.getItem(this.dataListCacheKey)
          ) {
            this.dataListObj["rescueProgress"] = JSON.parse(
              JSON.stringify(this.rescueProgress),
            );
          }
        })
        .catch((error) => {
          this.elevatorStatusLoading = false;
          this.$sentry.captureException(error);
        });
    },
    statisticsElevatorStatusCount() {
      this.sumElevatorCount = 0;
      this.liftData.forEach((item, i) => {
        item.value = 0;
      });
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(this.dataListCacheKey);
        if (json) {
          this.count++;
          let elevatorStatusArr = JSON.parse(json)["elevatorStatusArr"];
          if (elevatorStatusArr) {
            this.handleElevatorStatus(elevatorStatusArr);
          }
          this.startElevatorStatusTimer();
          return;
        }
      }
      this.elevatorStatusLoading = true;
      this.$http
        .post(this.$apiConfig.statistics_elevator_alarm_status_count_url, {
          type: 1,
          dataPermissionList: this.dataPermissionList,
        })
        .then((response) => {
          this.elevatorStatusLoading = false;
          let result = response.data;
          if (result.code == 0) {
            let elevatorStatusArr = result.data;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(this.dataListCacheKey)
            ) {
              this.dataListObj["elevatorStatusArr"] = elevatorStatusArr;
            } else if (elevatorStatusArr.length > 0) {
              this.handleElevatorStatus(elevatorStatusArr);
            }
          }
          this.count++;
          this.startElevatorStatusTimer();
        })
        .catch((error) => {
          this.startElevatorStatusTimer();
          // if (this.$refs.liftChart) {
          //   this.$refs.liftChart.initChart();
          // }
          this.elevatorStatusLoading = false;
          this.$sentry.captureException(error);
        });
    },
    handleElevatorStatus(elevatorStatusArr) {
      elevatorStatusArr.forEach((v, i) => {
        this.liftData.map((o) => {
          if (o.type == i) {
            o.value = v;
          }
        });
      });
      this.liftData[2].value =
        this.liftData[2].value -
        this.liftData[0].value -
        this.liftData[1].value;
      this.sumElevatorCount = 0;
      this.liftData.forEach((item, index) => {
        this.sumElevatorCount += item.value;
      });
      if (this.$refs.liftChart) {
        this.$refs.liftChart.initChart();
      }
    },
    startElevatorStatusTimer() {
      if (
        !this.$store.state.indexLiftStatusTimer &&
        this.$store.state.indexLiftStatusTimer != -1
      ) {
        this.$store.state.indexLiftStatusTimer = window.setInterval(
          this.statisticsElevatorStatusCount,
          window.config.indexLiftStatusTimerInterval,
        );
      }
    },
    statisticsMonitorStatusCount() {
      this.sumDeviceCount = 0;
      this.deviceData.forEach((item, i) => {
        item.value = 0;
      });
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(this.dataListCacheKey);
        if (json) {
          this.count++;
          let monitorStatusArr = JSON.parse(json)["monitorStatusArr"];
          if (monitorStatusArr) {
            this.handleMonitorStatus(monitorStatusArr);
          }
          this.startMonitorStatusTimer();
          return;
        }
      }
      this.deviceMonitorLoading = true;
      this.$http
        .post(this.$apiConfig.statistics_device_status_count_url, {
          type: 2,
          dataPermissionList: this.dataPermissionList,
        })
        .then((response) => {
          this.deviceMonitorLoading = false;
          let result = response.data;
          if (result.code == 0) {
            let monitorStatusArr = result.data;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(this.dataListCacheKey)
            ) {
              this.dataListObj["monitorStatusArr"] = monitorStatusArr;
            } else if (monitorStatusArr.length > 0) {
              this.handleMonitorStatus(monitorStatusArr);
            }
          }
          this.count++;
          this.startMonitorStatusTimer();
        })
        .catch((error) => {
          // if (this.$refs.deviceChart) {
          //   this.$refs.deviceChart.initChart();
          // }
          this.deviceMonitorLoading = false;
          this.startMonitorStatusTimer();
          this.$sentry.captureException(error);
        });
    },
    handleMonitorStatus(monitorStatusArr) {
      monitorStatusArr.forEach((item, index) => {
        let otherVal = 0;
        this.deviceData.map((o) => {
          if (o.type == item.name) {
            o.value += item.value;
          } else if (item.name == null) {
            otherVal = item.value;
          }
        });
        // if (otherVal > 0) {
        //   this.deviceData.forEach((item2, i) => {
        //     if (item2.type == "3") {
        //       this.deviceData[i].value += otherVal;
        //     }
        //   });
        // }
      });
      this.elevatorAbnormalCount = this.deviceData.filter(
        (n) => n.type == 0,
      )[0].value;

      this.sumDeviceCount = 0;
      this.deviceData.forEach((item, index) => {
        this.sumDeviceCount += item.value;
      });

      if (this.$refs.deviceChart) {
        this.$refs.deviceChart.initChart();
      }
    },
    startMonitorStatusTimer() {
      if (
        !this.$store.state.indexDeviceStatusTimer &&
        this.$store.state.indexDeviceStatusTimer != -1
      ) {
        this.$store.state.indexDeviceStatusTimer = window.setInterval(
          this.statisticsMonitorStatusCount,
          window.config.indexDeviceStatusTimerInterval,
        );
      }
    },
    statisticsMainPlanStatusCount() {
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(this.dataListCacheKey);
        if (json) {
          this.count++;
          let mainPlanStatusArr = JSON.parse(json)["mainPlanStatusArr"];
          if (mainPlanStatusArr) {
            this.handleMainPlanStatus(mainPlanStatusArr);
          }
          return;
        }
      }
      this.mainFinishLoading = true;
      this.$http
        .post(this.$apiConfig.statistics_main_plan_status_count_url, {
          dataPermissionList: this.dataPermissionList,
        })
        .then((response) => {
          this.mainFinishLoading = false;
          let result = response.data;
          if (result.code == 0) {
            let mainPlanStatusArr = result.data;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(this.dataListCacheKey)
            ) {
              this.dataListObj["mainPlanStatusArr"] = mainPlanStatusArr;
            } else if (mainPlanStatusArr.length > 0) {
              this.handleMainPlanStatus(mainPlanStatusArr);
            } else {
              this.repairData.sum = 0;
              this.repairData.value = 0;
            }
          }
          this.count++;
        })
        .catch((error) => {
          this.mainFinishLoading = false;
          this.$sentry.captureException(error);
        });
    },
    handleMainPlanStatus(mainPlanStatusArr) {
      let value = 0;
      mainPlanStatusArr.forEach((item, index) => {
        if (item.name == "已完成") {
          value = item.value;
        }
        this.repairData.sum += item.value;
      });
      this.repairData.value = value;
    },

    /* 获取无纸化保养记录 */
    getDateMaintainRecordDate() {
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(this.dataListCacheKey);
        if (json) {
          this.count++;
          this.calenderDate = JSON.parse(json)["calenderDate"];
          return;
        }
      }
      const cacheKey = "maintainDataCache";
      const cacheData = sessionStorage.getItem(cacheKey);
      if (cacheData) {
        const values = cacheData.split("#");
        if (values[1] == this.$common.formatDate(this.calenderDate.$DATE.$d)) {
          this.calenderDate.ds = JSON.parse(values[0]);
          return;
        } else {
          sessionStorage.removeItem(cacheKey);
        }
      }
      this.mainFinishLoading = true;
      this.$http
        .post(this.$apiConfig.get_elevator_maintain_record_date_url, {
          startDate: this.calenderDate.ds[0].date,
          endDate: this.calenderDate.ds[this.calenderDate.ds.length - 1].date,
        })
        .then((response) => {
          let result = response.data;
          this.mainFinishLoading = false;
          if (result.code != 0) return this.message(result.code, result.msg);
          let data = result.data;
          data.forEach((v) => {
            let index = this.calenderDate.ds.findIndex((t) => t.date == v.date);
            if (index != -1) {
              this.calenderDate.ds[index].planOrFinish = v.values;
            }
          });
          sessionStorage.setItem(
            cacheKey,
            JSON.stringify(this.calenderDate.ds) +
              "#" +
              this.$common.formatDate(this.calenderDate.$DATE.$d),
            { expires: 1 },
          );
          if (
            !this.loaded &&
            this.$store.state.pageScroll.scroll &&
            !sessionStorage.getItem(this.dataListCacheKey)
          ) {
            this.dataListObj["calenderDate"] = JSON.parse(
              JSON.stringify(this.calenderDate),
            );
          }
        })
        .catch((error) => {
          this.mainFinishLoading = false;
          this.$sentry.captureException(error);
        });
    },

    /* 获取电梯运行次数分布 */
    getElevatorRunTimesDistribute() {
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(this.dataListCacheKey);
        if (json) {
          this.count++;
          this.runTimesData = JSON.parse(json)["runTimesData"];
          return;
        }
      }
      this.deviceMonitorLoading = true;
      this.$http
        .post(this.$apiConfig.get_run_times_distribute_url, {})
        .then((response) => {
          let result = response.data;
          this.deviceMonitorLoading = false;
          if (result.code != 0) return this.message(result.code, result.msg);
          let data = result.data;
          this.runTimesData[5].value = data.count1;
          this.runTimesData[4].value = data.count2;
          this.runTimesData[3].value = data.count3;
          this.runTimesData[0].value = data.count4;
          this.runTimesData[1].value = data.count5;
          this.runTimesData[2].value = data.count6;
          if (
            !this.loaded &&
            this.$store.state.pageScroll.scroll &&
            !sessionStorage.getItem(this.dataListCacheKey)
          ) {
            this.dataListObj["runTimesData"] = JSON.parse(
              JSON.stringify(this.runTimesData),
            );
          } else {
            if (this.$refs.runTimesChart) {
              this.$refs.runTimesChart.initChart();
            }
          }
        })
        .catch((error) => {
          this.deviceMonitorLoading = false;
          this.$sentry.captureException(error);
        });
    },
    // statisticsOneWeekStopFaultCount(days) {
    //   if (this.$store.state.pageScroll.scroll) {
    //     const json = sessionStorage.getItem(this.dataListCacheKey);
    //     if (json) {
    //       this.count++;
    //       let oneWeekStopFaultArr = JSON.parse(json)["oneWeekStopFaultArr"];
    //       if (oneWeekStopFaultArr) {
    //         this.handleOneWeekStopFault(oneWeekStopFaultArr);
    //       }
    //       return;
    //     }
    //   }
    //   this.sevenDayFaultLoading = true;
    //   this.$http
    //     .post(this.$apiConfig.statistics_days_stop_fault_count_url, {
    //       days: days,
    //       dataPermissionList: this.dataPermissionList,
    //     })
    //     .then((response) => {
    //       this.sevenDayFaultLoading = false;
    //       let result = response.data;
    //       if (result.code == 0) {
    //         let oneWeekStopFaultArr = result.data;
    //         if (
    //           !this.loaded &&
    //           this.$store.state.pageScroll.scroll &&
    //           !sessionStorage.getItem(this.dataListCacheKey)
    //         ) {
    //           this.dataListObj["oneWeekStopFaultArr"] = oneWeekStopFaultArr;
    //         } else {
    //           this.handleOneWeekStopFault(oneWeekStopFaultArr);
    //         }
    //       }
    //       this.count++;
    //     })
    //     .catch((error) => {
    //       this.sevenDayFaultLoading = false;
    //       this.$sentry.captureException(error);
    //     });
    // },
    handleOneWeekStopFault(oneWeekStopFaultArr) {
      let names = [];
      let values = [];
      oneWeekStopFaultArr.forEach((item, index) => {
        names.push(item.name);
        values.push(item.value);
      });
      if (oneWeekStopFaultArr && oneWeekStopFaultArr.length > 0) {
        this.breakdownPoly = {};
        this.breakdownPoly.name = names;
        this.breakdownPoly.value = values;
      }
    },
    statisticsElevatorAgeCount() {
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(this.dataListCacheKey);
        if (json) {
          this.count++;
          let elevatorAgeArr = JSON.parse(json)["elevatorAgeArr"];
          if (elevatorAgeArr) {
            if (elevatorAgeArr.length == 5) {
              this.ageBar.category = this.ageCategory.slice(0, 5);
            } else {
              this.ageBar.category = this.ageCategory.filter((v) => true);
            }
            this.ageBar.value[0].data = elevatorAgeArr;
            this.$refs.liftAgeChart.initChart();
          }
          return;
        }
      } else {
        const result = sessionStorage.getItem("elevatorAgeBarData");
        if (result) {
          const arr = result.split("#");
          if (arr[0] == this.$common.formatDate()) {
            const elevatorAgeArr = JSON.parse(arr[1]);
            if (elevatorAgeArr.length == 5) {
              this.ageBar.category = this.ageCategory.slice(0, 5);
            } else {
              this.ageBar.category = this.ageCategory.filter((v) => true);
            }
            this.ageBar.value[0].data = elevatorAgeArr;
            this.$refs.liftAgeChart.initChart();
            return;
          } else {
            sessionStorage.removeItem("elevatorAgeBarData");
          }
        }
      }
      this.elevatorAgeLoading = true;
      this.$http
        .post(this.$apiConfig.statistics_elevator_age_count_url, {
          curDate: this.$common.formatDate(new Date()),
          dataPermissionList: this.dataPermissionList,
        })
        .then((response) => {
          this.elevatorAgeLoading = false;
          let result = response.data;
          if (result.code == 0) {
            let elevatorAgeArr = result.data;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(this.dataListCacheKey)
            ) {
              this.dataListObj["elevatorAgeArr"] = elevatorAgeArr;
            } else {
              sessionStorage.setItem(
                "elevatorAgeBarData",
                this.$common.formatDate() +
                  "#" +
                  JSON.stringify(elevatorAgeArr),
              );
              if (elevatorAgeArr.length == 6) {
                this.ageBar.category = this.ageCategory.slice(0, 5);
              } else {
                this.ageBar.category = this.ageCategory.filter((v) => true);
              }
              this.ageBar.value[0].data = elevatorAgeArr;
              if (this.$refs.liftAgeChart) {
                this.$refs.liftAgeChart.initChart();
              }
            }
          }
          this.count++;
        })
        .catch((error) => {
          this.elevatorAgeLoading = false;
          this.$sentry.captureException(error);
        });
    },
    searchMainPlanExpireCount() {
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(this.dataListCacheKey);
        if (json) {
          this.count++;
          let mainPlanExpireArr = JSON.parse(json)["mainPlanExpireArr"];
          if (mainPlanExpireArr) {
            this.handleMainPlanExpire(mainPlanExpireArr);
          }
          return;
        }
      }
      this.yearCheckLoading = true;
      this.$http
        .post(this.$apiConfig.search_year_cheak_list_url, {
          pageNum: 1,
          pageSize: 3,
          curDate: this.$common.formatDate(new Date()),
          expiryInterval: this.yearCheckTime * 30,
          dataPermissionList: this.dataPermissionList,
        })
        .then((response) => {
          this.yearCheckLoading = false;
          let result = response.data;
          if (result.code == 0) {
            let mainPlanExpireArr = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(this.dataListCacheKey)
            ) {
              this.dataListObj["mainPlanExpireArr"] = mainPlanExpireArr;
            } else {
              this.handleMainPlanExpire(mainPlanExpireArr);
            }
          }
          this.count++;
        })
        .catch((error) => {
          this.yearCheckLoading = false;
          this.$sentry.captureException(error);
        });
    },
    handleMainPlanExpire(mainPlanExpireArr) {
      if (mainPlanExpireArr) {
        this.annualAlarm = [];
        mainPlanExpireArr.forEach((item, index) => {
          this.annualAlarm.push({
            city: item.city,
            domainId: item.domainId,
            domainName: item.domainName,
            utils: item.utils,
          });
        });
      }
    },
    searchAgreementExpire() {
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(this.dataListCacheKey);
        if (json) {
          this.count++;
          let agreementExpireArr = JSON.parse(json)["agreementExpireArr"];
          if (agreementExpireArr) {
            this.handleAgreementExpire(agreementExpireArr);
          }
          return;
        }
      }
      this.contractLoading = true;
      this.$http
        .post(this.$apiConfig.search_contract_expire_list_url, {
          pageNum: 1,
          pageSize: 3,
          curDate: this.$common.formatDate(new Date()),
          expiryInterval: this.contractCheckTime * 30,
          dataPermissionList: this.dataPermissionList,
        })
        .then((response) => {
          this.contractLoading = false;
          let result = response.data;
          if (result.code == 0) {
            let agreementExpireArr = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(this.dataListCacheKey)
            ) {
              this.dataListObj["agreementExpireArr"] = agreementExpireArr;
            } else {
              this.handleAgreementExpire(agreementExpireArr);
            }
          }
          this.count++;
        })
        .catch((error) => {
          this.contractLoading = false;
          this.$sentry.captureException(error);
        });
    },
    handleAgreementExpire(agreementExpireArr) {
      if (agreementExpireArr) {
        this.contractAlarm = [];
        agreementExpireArr.forEach((item, index) => {
          this.contractAlarm.push({
            id: item.agreeNum,
            city: item.city,
            domainName: item.domainName,
            utils: item.utils,
            days: item.days,
            endDate: item.endDate,
          });
        });
      }
    },
    // 昨日遥监预警记录汇总 测试数据 strat
    // statisticsYesterdayStopFaultCount() {
    //   if (this.$store.state.pageScroll.scroll) {
    //     const json = sessionStorage.getItem(this.dataListCacheKey);
    //     if (json) {
    //       this.count++;
    //       let yesterdayStopFaultArr = JSON.parse(json)["yesterdayStopFaultArr"];
    //       if (yesterdayStopFaultArr) {
    //         this.handleYesterdayStopFault(yesterdayStopFaultArr);
    //       }
    //       return;
    //     }
    //   }
    //   this.yesterdayFaultLoading = true;
    //   this.$http
    //     .post(this.$apiConfig.statistics_yesterdy_stop_fault_count_url, {
    //       pageNum: 1,
    //       pageSize: 6,
    //       statisticType: 1,
    //       dataPermissionList: this.dataPermissionList,
    //     })
    //     .then((response) => {
    //       this.yesterdayFaultLoading = false;
    //       let result = response.data;
    //       if (result.code == 0) {
    //         const jsonStr =
    //           '[{"alarmId":null,"jobNum":null,"domainName":"沈阳市中旅万科城","serviceOrder":null,"alarmDate":null,"description":null,"sourceId":null,"processType":null,"processDate":null,"arriveDate":null,"finishDate":null,"createDate":null,"updateDate":null,"processedTime":null,"rescueTime":null,"boxUp":null,"serviceRequestSource":null,"rescueCompleteTime":null,"reasonAnalyze":null,"solveMethod":null,"domainId":"3PPKXDC","elevatorNum":null,"buildingName":null,"province":null,"city":"沈阳市","elevatorType":null,"elevatorAge":null,"techCertTime":null,"liftCount":151,"faultCount":2129,"registerCode":null,"brand":null,"inspectDate":null,"isactive":null,"monitorStatus":null,"elevatorStatus":null,"returnStatusName":null,"serviceOrder2":null,"returnFinishDatetime":null,"returnComplateDatetime":null,"returnDesc":null,"isReturnFinish":null,"finishRemark":null,"unreasonableDemands":null,"unreasonableRemark":null,"faultScore":null,"faultRemark":null,"attitudeScore":null,"attitudeRemark":null,"timelinessScore":null,"timelinessRemark":null,"mtScore":null,"mtRemark":null,"spareScore":null,"spareRemark":null,"custReturn":null,"compReturn":null,"compReturnPerson":null,"compReturnPersonTel":null,"evaluateContactPerson":null,"evaluateContactPersonTel":null,"trapCount":null,"trapFinishRate":null,"trapArrivalOvertimeCount":null,"trapRescueOvertimeCount":null,"riskScore":null,"riskEstimate":null,"mainFaultCode":null,"subFaultCode":null,"deviceSerial":null,"channelNo":null,"deviceType":null,"count1":null,"count2":null,"count3":null,"count4":null},{"alarmId":null,"jobNum":null,"domainName":"日照市虎山社区","serviceOrder":null,"alarmDate":null,"description":null,"sourceId":null,"processType":null,"processDate":null,"arriveDate":null,"finishDate":null,"createDate":null,"updateDate":null,"processedTime":null,"rescueTime":null,"boxUp":null,"serviceRequestSource":null,"rescueCompleteTime":null,"reasonAnalyze":null,"solveMethod":null,"domainId":"3T3WG3N","elevatorNum":null,"buildingName":null,"province":null,"city":"日照市","elevatorType":null,"elevatorAge":null,"techCertTime":null,"liftCount":133,"faultCount":1698,"registerCode":null,"brand":null,"inspectDate":null,"isactive":null,"monitorStatus":null,"elevatorStatus":null,"returnStatusName":null,"serviceOrder2":null,"returnFinishDatetime":null,"returnComplateDatetime":null,"returnDesc":null,"isReturnFinish":null,"finishRemark":null,"unreasonableDemands":null,"unreasonableRemark":null,"faultScore":null,"faultRemark":null,"attitudeScore":null,"attitudeRemark":null,"timelinessScore":null,"timelinessRemark":null,"mtScore":null,"mtRemark":null,"spareScore":null,"spareRemark":null,"custReturn":null,"compReturn":null,"compReturnPerson":null,"compReturnPersonTel":null,"evaluateContactPerson":null,"evaluateContactPersonTel":null,"trapCount":null,"trapFinishRate":null,"trapArrivalOvertimeCount":null,"trapRescueOvertimeCount":null,"riskScore":null,"riskEstimate":null,"mainFaultCode":null,"subFaultCode":null,"deviceSerial":null,"channelNo":null,"deviceType":null,"count1":null,"count2":null,"count3":null,"count4":null},{"alarmId":null,"jobNum":null,"domainName":"重庆融创溪山春晓","serviceOrder":null,"alarmDate":null,"description":null,"sourceId":null,"processType":null,"processDate":null,"arriveDate":null,"finishDate":null,"createDate":null,"updateDate":null,"processedTime":null,"rescueTime":null,"boxUp":null,"serviceRequestSource":null,"rescueCompleteTime":null,"reasonAnalyze":null,"solveMethod":null,"domainId":"40AG4ES","elevatorNum":null,"buildingName":null,"province":null,"city":"重庆市","elevatorType":null,"elevatorAge":null,"techCertTime":null,"liftCount":104,"faultCount":1357,"registerCode":null,"brand":null,"inspectDate":null,"isactive":null,"monitorStatus":null,"elevatorStatus":null,"returnStatusName":null,"serviceOrder2":null,"returnFinishDatetime":null,"returnComplateDatetime":null,"returnDesc":null,"isReturnFinish":null,"finishRemark":null,"unreasonableDemands":null,"unreasonableRemark":null,"faultScore":null,"faultRemark":null,"attitudeScore":null,"attitudeRemark":null,"timelinessScore":null,"timelinessRemark":null,"mtScore":null,"mtRemark":null,"spareScore":null,"spareRemark":null,"custReturn":null,"compReturn":null,"compReturnPerson":null,"compReturnPersonTel":null,"evaluateContactPerson":null,"evaluateContactPersonTel":null,"trapCount":null,"trapFinishRate":null,"trapArrivalOvertimeCount":null,"trapRescueOvertimeCount":null,"riskScore":null,"riskEstimate":null,"mainFaultCode":null,"subFaultCode":null,"deviceSerial":null,"channelNo":null,"deviceType":null,"count1":null,"count2":null,"count3":null,"count4":null},{"alarmId":null,"jobNum":null,"domainName":"汕头市南信纺织产业园区建设有限公司","serviceOrder":null,"alarmDate":null,"description":null,"sourceId":null,"processType":null,"processDate":null,"arriveDate":null,"finishDate":null,"createDate":null,"updateDate":null,"processedTime":null,"rescueTime":null,"boxUp":null,"serviceRequestSource":null,"rescueCompleteTime":null,"reasonAnalyze":null,"solveMethod":null,"domainId":"44W4AK1","elevatorNum":null,"buildingName":null,"province":null,"city":"汕头市","elevatorType":null,"elevatorAge":null,"techCertTime":null,"liftCount":156,"faultCount":1036,"registerCode":null,"brand":null,"inspectDate":null,"isactive":null,"monitorStatus":null,"elevatorStatus":null,"returnStatusName":null,"serviceOrder2":null,"returnFinishDatetime":null,"returnComplateDatetime":null,"returnDesc":null,"isReturnFinish":null,"finishRemark":null,"unreasonableDemands":null,"unreasonableRemark":null,"faultScore":null,"faultRemark":null,"attitudeScore":null,"attitudeRemark":null,"timelinessScore":null,"timelinessRemark":null,"mtScore":null,"mtRemark":null,"spareScore":null,"spareRemark":null,"custReturn":null,"compReturn":null,"compReturnPerson":null,"compReturnPersonTel":null,"evaluateContactPerson":null,"evaluateContactPersonTel":null,"trapCount":null,"trapFinishRate":null,"trapArrivalOvertimeCount":null,"trapRescueOvertimeCount":null,"riskScore":null,"riskEstimate":null,"mainFaultCode":null,"subFaultCode":null,"deviceSerial":null,"channelNo":null,"deviceType":null,"count1":null,"count2":null,"count3":null,"count4":null},{"alarmId":null,"jobNum":null,"domainName":"梅州市保利江南和府一期","serviceOrder":null,"alarmDate":null,"description":null,"sourceId":null,"processType":null,"processDate":null,"arriveDate":null,"finishDate":null,"createDate":null,"updateDate":null,"processedTime":null,"rescueTime":null,"boxUp":null,"serviceRequestSource":null,"rescueCompleteTime":null,"reasonAnalyze":null,"solveMethod":null,"domainId":"40NJARK","elevatorNum":null,"buildingName":null,"province":null,"city":"梅州市","elevatorType":null,"elevatorAge":null,"techCertTime":null,"liftCount":109,"faultCount":948,"registerCode":null,"brand":null,"inspectDate":null,"isactive":null,"monitorStatus":null,"elevatorStatus":null,"returnStatusName":null,"serviceOrder2":null,"returnFinishDatetime":null,"returnComplateDatetime":null,"returnDesc":null,"isReturnFinish":null,"finishRemark":null,"unreasonableDemands":null,"unreasonableRemark":null,"faultScore":null,"faultRemark":null,"attitudeScore":null,"attitudeRemark":null,"timelinessScore":null,"timelinessRemark":null,"mtScore":null,"mtRemark":null,"spareScore":null,"spareRemark":null,"custReturn":null,"compReturn":null,"compReturnPerson":null,"compReturnPersonTel":null,"evaluateContactPerson":null,"evaluateContactPersonTel":null,"trapCount":null,"trapFinishRate":null,"trapArrivalOvertimeCount":null,"trapRescueOvertimeCount":null,"riskScore":null,"riskEstimate":null,"mainFaultCode":null,"subFaultCode":null,"deviceSerial":null,"channelNo":null,"deviceType":null,"count1":null,"count2":null,"count3":null,"count4":null},{"alarmId":null,"jobNum":null,"domainName":"中南玖熙墅","serviceOrder":null,"alarmDate":null,"description":null,"sourceId":null,"processType":null,"processDate":null,"arriveDate":null,"finishDate":null,"createDate":null,"updateDate":null,"processedTime":null,"rescueTime":null,"boxUp":null,"serviceRequestSource":null,"rescueCompleteTime":null,"reasonAnalyze":null,"solveMethod":null,"domainId":"1-21JW3MH","elevatorNum":null,"buildingName":null,"province":null,"city":"沈阳市","elevatorType":null,"elevatorAge":null,"techCertTime":null,"liftCount":52,"faultCount":677,"registerCode":null,"brand":null,"inspectDate":null,"isactive":null,"monitorStatus":null,"elevatorStatus":null,"returnStatusName":null,"serviceOrder2":null,"returnFinishDatetime":null,"returnComplateDatetime":null,"returnDesc":null,"isReturnFinish":null,"finishRemark":null,"unreasonableDemands":null,"unreasonableRemark":null,"faultScore":null,"faultRemark":null,"attitudeScore":null,"attitudeRemark":null,"timelinessScore":null,"timelinessRemark":null,"mtScore":null,"mtRemark":null,"spareScore":null,"spareRemark":null,"custReturn":null,"compReturn":null,"compReturnPerson":null,"compReturnPersonTel":null,"evaluateContactPerson":null,"evaluateContactPersonTel":null,"trapCount":null,"trapFinishRate":null,"trapArrivalOvertimeCount":null,"trapRescueOvertimeCount":null,"riskScore":null,"riskEstimate":null,"mainFaultCode":null,"subFaultCode":null,"deviceSerial":null,"channelNo":null,"deviceType":null,"count1":null,"count2":null,"count3":null,"count4":null}]';
    //         let yesterdayStopFaultArr = JSON.parse(jsonStr); //result.data.result;
    //         if (
    //           !this.loaded &&
    //           this.$store.state.pageScroll.scroll &&
    //           !sessionStorage.getItem(this.dataListCacheKey)
    //         ) {
    //           this.dataListObj["yesterdayStopFaultArr"] = yesterdayStopFaultArr;
    //         } else {
    //           this.handleYesterdayStopFault(yesterdayStopFaultArr);
    //         }
    //       }
    //       this.count++;
    //     })
    //     .catch((error) => {
    //       this.yesterdayFaultLoading = false;
    //       this.$sentry.captureException(error);
    //     });
    // },
    //测试数据 end
    statisticsYesterdayStopFaultCount() {
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(this.dataListCacheKey);
        if (json) {
          this.count++;
          let yesterdayStopFaultArr = JSON.parse(json)["yesterdayStopFaultArr"];
          if (yesterdayStopFaultArr) {
            this.handleYesterdayStopFault(yesterdayStopFaultArr);
          }
          return;
        }
      }
      this.yesterdayFaultLoading = true;
      this.$http
        .post(this.$apiConfig.statistics_yesterdy_stop_fault_count_url, {
          pageNum: 1,
          pageSize: 6,
          statisticType: 1,
          dataPermissionList: this.dataPermissionList,
        })
        .then((response) => {
          this.yesterdayFaultLoading = false;
          let result = response.data;
          if (result.code == 0) {
            let yesterdayStopFaultArr = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(this.dataListCacheKey)
            ) {
              this.dataListObj["yesterdayStopFaultArr"] = yesterdayStopFaultArr;
            } else {
              this.handleYesterdayStopFault(yesterdayStopFaultArr);
            }
          }
          this.count++;
        })
        .catch((error) => {
          this.yesterdayFaultLoading = false;
          this.$sentry.captureException(error);
        });
    },
    handleYesterdayStopFault(yesterdayStopFaultArr) {
      this.breakdownLift = [];
      if (yesterdayStopFaultArr) {
        yesterdayStopFaultArr.forEach((item, index) => {
          this.breakdownLift.push({
            city: item.city,
            domainId: item.domainId,
            domainName: item.domainName,
            liftCount: item.liftCount,
            faultCount: item.faultCount,
          });
        });
      }
    },
    searchRealElevatorFault() {
      if (this.scrollList.length == 0) {
        this.realFollowLoading = true;
      }
      this.$http
        .post(this.$apiConfig.search_real_elevator_fault_url, {
          dataPermissionList: this.dataPermissionList,
        })
        .then((response) => {
          if (this.realFollowLoading) {
            this.realFollowLoading = false;
          }
          let result = response.data;
          if (result.code == 0) {
            const time = new Date().getTime();
            if (
              !this.$store.state.checkIndexRealTimer &&
              this.$store.state.checkIndexRealTimer != -1
            ) {
              this.$store.state.checkIndexRealTimer = window.setInterval(() => {
                let tempArr = [];
                this.scrollList.forEach((item, index) => {
                  if (item.remove && time - item.showTime >= 10000) {
                    if (item.type == 3) {
                      this.saveFinishRealFollow(item.id, item.updateTime);
                    } else {
                      this.saveFinishRealFollow(item.id);
                    }
                  } else {
                    tempArr.push(item);
                  }
                });
                this.scrollList = tempArr;
              }, 1000);
            }
            let data = result.data;
            const key = this.$store.state.user.username + "_real_follow";
            const val = localStorage.getItem(key);
            let json = null;
            const date = this.$common
              .formatDate()
              .replace("-", "")
              .replace("-", "");
            if (val) {
              json = JSON.parse(val);
              if (json.date != date) {
                localStorage.removeItem(key);
                json = null;
              }
            }
            if (this.scrollList.length == 0) {
              let arr = [];
              data.forEach((item, index) => {
                if (
                  !json ||
                  json.data.filter(
                    (v) =>
                      v.id == item.id &&
                      (item.type != 3 || v.time == item.updateTime),
                  ).length == 0
                ) {
                  item.time = item.updateTime.split(" ")[1].substring(0, 5);
                  if (item.remove) {
                    item.showTime = time;
                  }
                  arr.push(item);
                }
              });
              this.scrollList = arr;
            } else {
              let tempArr = [];
              data.forEach((item, index) => {
                if (
                  !json ||
                  json.data.filter(
                    (v) =>
                      v.id == item.id &&
                      (item.type != 3 || v.time == item.updateTime),
                  ).length == 0
                ) {
                  const arr = this.scrollList.filter((t) => t.id == item.id);
                  if (arr.length == 1) {
                    if (!arr[0].remove && item.remove) {
                      item.showTime = time;
                    } else if (item.remove) {
                      item.showTime = arr[0].showTime;
                    }
                    if (!item.showTime || time - item.showTime < 10000) {
                      item.time = item.updateTime.split(" ")[1].substring(0, 5);
                      tempArr.push(item);
                    } else {
                      if (item.type == 3) {
                        this.saveFinishRealFollow(item.id, item.updateTime);
                      } else {
                        this.saveFinishRealFollow(item.id);
                      }
                    }
                  } else {
                    if (item.remove) {
                      item.showTime = time;
                    }
                    item.time = item.updateTime.split(" ")[1].substring(0, 5);
                    tempArr.push(item);
                  }
                }
              });
              this.scrollList = tempArr;
            }
          }
          if (this.$store.state.indexRealTimer != -1) {
            this.$store.state.indexRealTimer = window.setTimeout(() => {
              this.searchRealElevatorFault();
            }, window.config.indexRealTimerInterval);
          }
        })
        .catch((error) => {
          if (this.realFollowLoading) {
            this.realFollowLoading = false;
          }
          if (this.$store.state.indexRealTimer != -1) {
            this.$store.state.indexRealTimer = window.setTimeout(() => {
              this.searchRealElevatorFault();
            }, window.config.indexRealTimerInterval);
          }
          this.$sentry.captureException(error);
        });
    },
    saveFinishRealFollow(id, time) {
      const key = this.$store.state.user.username + "_real_follow";
      const date = this.$common.formatDate().replace("-", "").replace("-", "");
      const val = localStorage.getItem(key);
      let obj = { id: id };
      if (time) {
        obj.time = time;
      }
      if (val) {
        let json = JSON.parse(val);
        if (json.date != date) {
          json.date = date;
          json.data = [obj];
          localStorage.setItem(key, JSON.stringify(json));
        } else {
          if (
            json.data.filter((v) => v.id == id && (!time || v.time == time))
              .length == 0
          ) {
            json.data.push(obj);
            localStorage.setItem(key, JSON.stringify(json));
          }
        }
      } else {
        localStorage.setItem(key, JSON.stringify({ date: date, data: [obj] }));
      }
    },
    openList(type, id, city, endDate) {
      this.listType = type;
      this.listDialogVisible = true;
      this.form.pageNum = 1;
      this.form.pageSize = 10;
      this.form.city = null;
      this.pageConfig.total = 0;
      if (type == 1) {
        this.form.pageName = "index";
        this.form.domainId = id;
        this.form.city = city;
        this.listUrl = this.$apiConfig.search_elevator_url;
        this.listDialogTitle = "年检提醒列表";
        this.form.expiryInterval = this.yearCheckTime * 30;
      } else if (type == 2) {
        this.form.agreeNum = id;
        this.form.curEndDate = endDate;
        this.listUrl = this.$apiConfig.search_agreement_url;
        this.listDialogTitle = "合同提醒列表";
        this.form.expiryInterval = this.contractCheckTime * 30;
      } else if (type == 3) {
        this.listUrl = this.$apiConfig.statistics_yesterdy_stop_fault_count_url;
        this.form.statisticType = 2;
        this.form.domainId = id;
        this.listDialogTitle = "昨日遥监预警记录汇总列表";
      } else if (type == 4) {
        // this.listUrl = this.$apiConfig.search_elevator_stop_list_url;
        // if (id) {
        //   this.form.startDate = id;
        //   this.form.days = 0;
        // } else {
        //   this.form.startDate = null;
        //   this.form.days = this.breakdownDateCheck;
        // }
        // this.listDialogTitle = this.stopLiftTitle;
        this.form.pageName = "lift";
        this.listUrl = this.$apiConfig.search_elevator_url;
        this.listDialogTitle = "运行次数列表";
      }
      this.loadData(this.listUrl);
    },
    loadData(url) {
      this.tableType = 1;
      // this.form.pageNum = this.pageConfig.currentPage;
      // this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      this.listLoading = true;
      this.$http
        .post(url, {
          pageNum: this.form.pageNum,
          pageSize: this.form.pageSize,
          curDate:
            this.listType == 4 ? null : this.$common.formatDate(new Date()),
          expiryInterval: this.form.expiryInterval,
          pageName: this.form.pageName,
          domainId: this.form.domainId,
          city: this.form.city,
          agreeNum: this.form.agreeNum,
          statisticType: this.form.statisticType,
          days: this.form.days,
          startDate: this.form.startDate,
          dataPermissionList: this.dataPermissionList,
          curEndDate: this.form.curEndDate,
        })
        .then((response) => {
          this.listLoading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.listLoading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    initData() {
      this.calenderDate = this.$common.getCurrentOrRestDate();
      this.apiCount = 0;
      // if (this.hasIndexPermission("电梯状态")) {
      //   this.apiCount++;
      //   this.statisticsElevatorStatusCount();
      // }
      if (this.hasIndexPermission("今日救援进度统计")) {
        this.apiCount++;
        this.getRescueProgressData();
      }
      // if (this.hasIndexPermission("遥监设备状态")) {
      //   this.apiCount++;
      //   this.statisticsMonitorStatusCount();
      // }
      // if (this.hasIndexPermission("今月保养完成情况")) {
      //   this.apiCount++;
      //   this.statisticsMainPlanStatusCount();
      // }
      if (this.hasIndexPermission("无纸化保养记录")) {
        this.apiCount++;
        this.getDateMaintainRecordDate();
      }
      if (this.hasIndexPermission("运行次数分布")) {
        this.apiCount++;
        this.getElevatorRunTimesDistribute();
      }
      // if (this.hasIndexPermission("近7天故障停梯故障趋势")) {
      //   this.apiCount++;
      //   this.statisticsOneWeekStopFaultCount(7);
      // }
      if (this.hasIndexPermission("年检提醒")) {
        this.apiCount++;
        this.searchMainPlanExpireCount();
      }
      if (this.hasIndexPermission("梯龄分布")) {
        this.apiCount++;
        this.statisticsElevatorAgeCount();
      }
      if (this.hasIndexPermission("合同提醒")) {
        this.apiCount++;
        this.searchAgreementExpire();
      }
      if (this.hasIndexPermission("昨日遥监预警记录汇总")) {
        this.apiCount++;
        this.statisticsYesterdayStopFaultCount();
      }
      if (this.hasIndexPermission("今日实时关注信息")) {
        this.searchRealElevatorFault();
      }
      let timer = window.setInterval(() => {
        if (this.count == this.apiCount) {
          this.count = 0;
          if (!this.loaded) {
            sessionStorage.setItem(
              this.dataListCacheKey,
              JSON.stringify(this.dataListObj),
            );
          } else if (this.$store.state.pageScroll.scroll) {
            sessionStorage.removeItem(this.dataListCacheKey);
          }
          window.clearInterval(timer);
        }
      }, 100);
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.viewDetailNum(this.jobNumListType);
    },
    viewDetailNum(type) {
      this.jobNumListType = type;
      this.tableType = 2;
      this.jobNumListDialogVisible = true;
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      this.jobNumListLoading = true;
      let json = {
        pageNum: this.form.pageNum,
        pageSize: this.form.pageSize,
      };
      let url = this.$apiConfig.search_device_patrol_job_num_url;
      if (type == 1) {
        json.elevatorStatus = this.jobNumForm.elevatorStatus;
      } else if (type == 2) {
        url = this.$apiConfig.search_main_plan_job_num_url;
        json.planStatus = this.jobNumForm.planStatus;
      } else {
        json.monitorStatus = this.jobNumForm.monitorStatus;
        url = this.$apiConfig.search_device_patrol_monitor_job_num_url;
      }
      json.dataPermissionList = this.dataPermissionList;
      this.$http
        .post(url, json)
        .then((response) => {
          this.jobNumListLoading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.jobNumListLoading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    elevatorStatusFormatter(row) {
      for (let i = 0; i < this.elevatorStatusArr.length; i++) {
        if (this.elevatorStatusArr[i].type == row.elevatorStatus) {
          return this.elevatorStatusArr[i].text;
        }
        // else if (row.elevatorStatus == 2 || row.elevatorStatus == 5) {
        //   return "其它";
        // }
      }
      return "";
    },
    monitorStatusFormatter(row) {
      for (let i = 0; i < this.monitorStatusArr.length; i++) {
        if (this.monitorStatusArr[i].value == row.isactive) {
          return this.monitorStatusArr[i].text;
        }
      }
      return "";
    },
    polyItemClick(param) {
      this.openList(4, param.name.replace("/", "-").replace("/", "-"));
    },
    exportData(id) {
      this.fullLoading = true;
      let name = "";
      let url = "";
      if (this.listType == 1) {
        name = "电梯年检提醒表_";
        url = this.$apiConfig.export_elevator_url;
      } else if (this.listType == 2) {
        name = "电梯合同提醒表_";
        url = this.$apiConfig.export_agreement_url;
      } else if (this.listType == 3) {
        name = "昨日遥监预警记录汇总表_";
        url = this.$apiConfig.export_yesterdy_stop_fault_url;
      } else if (this.listType == 4) {
        name = "运行次数分布表_";
        url = this.$apiConfig.export_elevator_run_count_url;
      }
      let filename = name + this.$common.formatCurrentDateTime(false) + ".xlsx";
      let data = {};
      for (let key in this.form) {
        data[key] = this.form[key];
      }
      data.curDate =
        this.listType == 4 ? null : this.$common.formatDate(new Date());
      data.dataPermissionList = this.dataPermissionList;
      this.$http({
        url: url,
        method: "post",
        responseType: "blob",
        data: data,
      })
        .then((response) => {
          this.fullLoading = false;
          const status = response.status;
          if (status != 200) {
            this.message(
              1,
              status == 201
                ? "导出失败"
                : status == 202
                ? "没有数据"
                : "数据量过大",
            );
            return;
          }
          const data = response.data;
          var blob = new Blob([data]);
          //判断是不是ie的浏览器
          if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.download = filename;
            aLink.href = url;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    changeDate(step) {
      if (step) {
        this.calenderDate = this.$common.getCurrentOrRestDate(
          this.calenderDate.$DATE.add(1, "months"),
        );
        this.getDateMaintainRecordDate();
      } else {
        this.calenderDate = this.$common.getCurrentOrRestDate(
          this.calenderDate.$DATE.add(-1, "months"),
        );
        this.getDateMaintainRecordDate();
      }
      this.datePickerValue = this.calenderDate.$DATE.$d;
    },
    changeCalenderDate(date) {
      this.calenderDate = this.$common.getCurrentOrRestDate(dayjs(date));
      this.getDateMaintainRecordDate();
    },
    openAlarm(type, index) {
      this.$router.push({
        path: "/manage/alarm",
        query: {
          source: "index",
          atype: type,
          index,
          date: this.$common.formatDate(),
        },
      });
    },
    openMaintain(type, date) {
      this.$router.push({
        path: "/maintain/maintainManage",
        query: {
          source: "index",
          type,
          date,
        },
      });
    },
    calcBeforeDate(beforeDateStr, nowDateStr) {
      const beforeDate = new Date(beforeDateStr + " 00:00:00");
      const nowDate = new Date(
        nowDateStr.substring(0, 4) +
          "-" +
          nowDateStr.substring(4, 6) +
          "-" +
          nowDateStr.substring(6, 8) +
          " 00:00:00",
      );
      return beforeDate.getTime() <= nowDate.getTime();
    },
  },
};
</script>
<style lang="scss" scoped>
.index {
  // margin-top: -10px;
  .advert-banner {
    position: relative;
    margin-bottom: 16px;
    .advert-box {
      position: relative;
      cursor: pointer;
      line-height: 0;
      width: 100%;
      aspect-ratio: 5 / 1;
      background: #f2f3f5;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }
    .advert-img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      border-radius: 8px;
      display: block;
      object-fit: contain;
    }
    .advert-close {
      position: absolute;
      right: 10px;
      top: 10px;
      width: 24px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      font-size: 16px;
      color: #fff;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
      cursor: pointer;
      &:hover {
        background: rgba(0, 0, 0, 0.7);
      }
    }
  }
  .banner-carousel-wrap {
    position: relative;
    width: 100%;
    margin-bottom: 16px;
    .banner-carousel {
      width: 100%;
      border-radius: 8px;
      overflow: hidden;
      background: #f2f3f5;
      .banner-img {
        width: 100%;
        height: 100%;
        object-fit: fill;
        display: block;
      }
    }
    .banner-close {
      position: absolute;
      top: 8px;
      right: 8px;
      z-index: 10;
      width: 24px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      font-size: 14px;
      color: #fff;
      background: rgba(0, 0, 0, 0.4);
      border-radius: 50%;
      cursor: pointer;
      &:hover {
        background: rgba(0, 0, 0, 0.6);
      }
    }
  }
  .advert-pop-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    .advert-pop-img {
      width: 600px;
      max-height: 70vh;
      object-fit: contain;
      cursor: pointer;
      display: block;
    }
    .advert-pop-close {
      margin-top: 12px;
      width: 32px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      font-size: 18px;
      color: #fff;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
      cursor: pointer;
      i {
        line-height: 32px;
      }
      &:hover {
        background: rgba(0, 0, 0, 0.7);
      }
    }
  }
  &-pie {
    /deep/ .panel-c {
      height: 270px;
      position: relative;
      // &::before,
      // &::after {
      //   content: "";
      //   position: absolute;
      //   bottom: 0;
      //   height: 100%;
      //   width: 10px;
      //   background: #e3e7ec;
      //   z-index: 2;
      // }
      // &::before {
      //   left: 0;
      // }
      // &::after {
      //   right: 0;
      // }
    }
  }
  &-breakdown {
    // height: 281px;
    /deep/ .panel-c {
      overflow-x: hidden;
    }
    .noticeList {
      em {
        font-size: 21px;
        color: $--color-text-primary;
      }
      li > span {
        position: relative;
        top: 10px;
      }
    }
  }
  .viewDetailNum {
    display: inline-block;
    position: relative;
    left: 20px;
    bottom: 36px;
    cursor: pointer;
    color: $--color-text-regular;
    border: 1px solid $--border-color-base;
    border-radius: 10em;
    font-size: $--font-size-small;
    line-height: 1.8;
    padding: 0 0.5em 0 1em;
    transition: all 0.2s ease;
    &:after {
      // position: relative;
      // left: 0;
      content: "\e6e0";
      font-family: element-icons !important;
      margin-left: 0.3em;
      transition: all 0.2s ease;
    }
    &:hover {
      padding-left: 1.5em;
      color: $--color-text-primary;
      &:after {
        // left: 2px;
        margin-left: 0.6em;
      }
    }
  }
}

.noticeList {
  padding: 0 $--base-padding;
  li {
    padding: 12px 0;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid $--border-color-lighter;
    &:last-child {
      border-bottom: 0;
    }
    > div {
      flex: 1;
    }
    h4 {
      display: inline-block;
      font-size: 21px;
      width: 35px;
      height: 35px;
      min-width: 35px;
      line-height: 35px;
      border-radius: 50%;
      margin-right: 15px;
      text-align: center;
      background: $--background-color-lighter;
    }
    p {
      font-size: $--font-size-large;
      line-height: 1.4;
      small {
        font-size: $--font-size-small;
        color: $--color-text-secondary;
      }
      .se {
        margin: 0 0.8em;
        color: $--border-color-light;
      }
    }
    h5 {
      font-size: 1.1em;
      line-height: 1.4;
    }

    span {
      // float: left;
      // text-align: right;
      color: $--color-text-secondary;
      // color: $--color-text-regular;
      font-size: $--font-size-small;
      white-space: nowrap;
      b {
        color: $--color-text-primary;
        font-weight: normal;
        margin: 0 5px;
      }
      em {
        margin: 0 5px;
        font-size: 30px;
        color: $--color-primary;
      }
    }
  }

  &--rank {
    li:nth-child(1) {
      h4 {
        background: $--color-primary;
        color: #fff;
      }
      em {
        color: $--color-primary;
      }
    }
    li:nth-child(2) {
      h4 {
        background: mix(#fff, $--color-primary, 40%);
        color: #fff;
      }
      em {
        color: $--color-primary;
      }
    }
    li:nth-child(3) {
      h4 {
        background: $--border-color-light;
      }
      em {
        color: $--color-primary;
      }
    }
  }

  &--card {
    padding: 0 10px;
    li {
      padding: 12px 15px;
      border: none;
      background: #ffffff;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04);
      border-radius: 12px;
      margin-top: 8px;
      h5 {
        font-size: 16px;
        margin-bottom: 2px;
      }
    }
  }
  .state-primary {
    em {
      color: $--color-primary;
    }
  }
  .state-success {
    em {
      color: $--color-success;
    }
  }
  .state-warning {
    em {
      color: $--color-warning;
    }
  }
}
.btn-group {
  .el-button {
    position: relative;
    font-weight: bold;
    padding: 15px 20px;
    border: 0;
    overflow: hidden;
    // box-shadow: 0 5px 10px -2px rgba(0, 0, 0, 0.2);
    &:before {
      position: absolute;
      left: 0px;
      top: 30%;
      // margin-top: -0.5em;
      z-index: 1;
      transform: rotate(-15deg);
      opacity: 0.4;
      font-size: 2.4em;
      content: "\e785";
      font-family: element-icons !important;
      speak: none;
      font-weight: 400;
      text-transform: none;
      line-height: 1;
      vertical-align: baseline;
      display: inline-block;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
    /deep/ span {
      position: relative;
      z-index: 9;
      text-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);
    }
    &--danger {
      background: linear-gradient(to right, $--color-danger, #ff946b);
      box-shadow: 0 8px 10px -5px rgba(darken($--color-danger, 20%), 0.5);
    }
    &--success {
      background: linear-gradient(to right, $--color-success, #acd668);
      box-shadow: 0 8px 10px -5px rgba(darken($--color-success, 10%), 0.5);
    }
    &--primary {
      background: linear-gradient(to right, $--color-primary, #4cd6ec);
      box-shadow: 0 8px 10px -5px rgba(darken($--color-primary, 20%), 0.5);
    }
  }
}

.select-light {
  float: left;
  width: 100px;
  vertical-align: top;
  /deep/ .el-input {
    font-size: $--font-size-small;
  }
  /deep/ .el-input__inner {
    background: #f3f3f3;
    border: 0;
    color: $--color-text-regular;
    height: 26px;
    line-height: 26px;
  }
}

.autoscroll-content {
  height: 209px;
  overflow: hidden;
}

.emptydata {
  color: $--color-text-regular;
  text-align: center;
  justify-content: space-around;
  padding-top: 6em !important;
  background: none !important;
  box-shadow: none !important;
}
/deep/ .el-loading-mask {
  z-index: 0;
}

.rescue-view {
  .rescue-items {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 6px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .tip {
    width: 100%;
    // margin-bottom: 6px;
    p {
      display: inline-block;
      border-radius: 4px;
      padding: 0 10px;
      line-height: 24px;
      font-size: 13px;
      margin: 10px 0px 10px 20px;
    }
  }
  .maintain {
    p {
      color: $--color-info;
      background: rgba($--color-info, 0.1);
    }
    .progress-bar {
      span {
        // color: $--color-info;
      }
    }
    .progress-bar-icon {
      color: $--color-info;
    }
  }
  .rescue {
    p {
      color: $--color-primary;
      background: rgba($--color-primary, 0.1);
    }
    .progress-bar {
      span {
        // color: $--color-primary;
      }
    }
    .progress-bar-icon {
      color: $--color-primary;
    }
    .progress-box::before {
      border-color: $--color-primary;
    }
  }
  .progress-box {
    width: 94%;
    flex: 1;
    display: flex;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 25px;
      left: 10%;
      // height: 3px;
      width: 80%;
      // background-color: #fff;
      border-top: 2px dotted $--color-info;
    }
  }
  .bar-box {
    width: 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
  .progress-bar {
    height: 52px;
    width: 52px;
    position: relative;
    margin-bottom: 10px;
    color: $--color-text-primary;
    cursor: pointer;
    &::before {
      content: "";
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
      width: 60px;
      height: 60px;
      border: 1px solid #e4e4e4;
      border-radius: 60px;
      background-color: #fff;
    }
    &-icon {
      line-height: 1;
      .svg-icon {
        width: 18px;
        height: 18px;
      }
    }
  }
  .text {
    color: $--color-text-secondary;
    font-size: 12px;
    em {
      color: $--color-text-regular;
    }
  }
}
.select-date {
  // position: absolute;
  // top: -38px;
  // left: 54%;
  // width: 235px;
  display: flex;
  align-items: center;
  margin-right: -14px;
  .left,
  .right {
    width: 16px;
    height: 16px;
    border-radius: 16px;
    // background-color: #b9c1cb;
    text-align: center;
    line-height: 14px;
    color: rgba($--color-text-primary, 0.5);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &:hover {
      background-color: rgba(#fff, 0.5);
      color: rgba($--color-text-primary, 1);
    }
  }
  .el-icon-arrow-left:before,
  .el-icon-arrow-right:before {
    font-size: 12px;
  }
  .month {
    width: 92px;
    margin: 0 4px;
    text-align: center;
    display: block;
    color: $--color-text-primary;
    background-color: rgba(#fff, 0.5);
    font-size: 13px;
    height: 26px;
    line-height: 26px;
    border-radius: 10em;
    position: relative;
    > i {
      margin-left: 2px;
      margin-right: -2px;
    }
    ::v-deep .custom-date-picker,
    /deep/.custom-date-picker {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      &.el-input {
        width: 100%;
      }
      &.el-input--suffix {
        .el-input__inner {
          height: 100%;
        }
      }
      .el-input__inner {
        opacity: 0;
        padding: 0 !important;
        overflow: hidden;
        cursor: pointer;
      }
    }
  }
}
.legend {
  min-width: 86px;
  position: absolute;
  width: 100%;
  bottom: 0px;
  // right: 8px;
  padding: 10px 0;
  // position: relative;
  display: flex;
  line-height: 1.5;
  justify-content: center;
  .plan,
  .finish {
    font-size: 12px;
    padding: 0 2em;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $--color-text-secondary;
    &:before {
      content: "";
      margin-right: 8px;
      width: 6px;
      height: 6px;
      border-radius: 2px;
    }
  }
  .plan {
    em {
      font-size: 14px;
      margin-left: 4px;
      color: $--color-primary;
      font-weight: bold;
      font-style: normal;
    }
  }
  .finish {
    em {
      font-size: 14px;
      margin-left: 4px;
      color: $--color-text-primary;
      font-weight: bold;
      font-style: normal;
    }
  }
  .plan {
    // color: $--color-primary;
    &:before {
      background-color: $--color-primary;
    }
  }
  .finish {
    // color: $--color-text-primary;
    &:before {
      background-color: $--color-text-primary;
      top: 24px;
    }
  }
}
.main-record {
  margin: 8px 14px;
  .title,
  .content {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px 0.5vw;
  }
  .title-text {
    text-align: center;
    font-size: 12px;
    // margin-right: 10px;
    // font-weight: 600;
    color: #868b91;
    margin: 4px 0 8px;
  }
  .item {
    font-size: 12px;
    background: rgba(#ffffff, 0.8);
    border-radius: 8px;
    padding: 0 5px 5px;
  }
  .item-day {
    display: block;
    text-align: center;
    color: #545e6d;
    font-weight: bold;
    line-height: 30px;
  }
  .item-not-plan {
    display: block;
    background: #ecf1f7;
    font-size: 11px;
    margin: 10px 0px 12px 0px;
  }
  .item-plan {
    display: block;
    color: #ffffff;
    margin-bottom: 4px;
    border-radius: 10em;
    padding-left: 6px;
    cursor: pointer;
  }
  .item-finish {
    display: block;
    color: #ffffff;
    border-radius: 10em;
    padding-left: 6px;
    cursor: pointer;
  }
  .item-plan,
  .item-finish {
    background-color: rgba($--color-black, 0.1);
  }
  .activated .item-day {
    color: #bac1cb;
  }
  .activated .item-plan,
  .activated .item-finish {
    opacity: 0.5;
    // background-color: #d7dadf;
  }
  .activate .item-plan {
    background-color: rgba($--color-primary, 0.8);
  }
  .activate .item-finish {
    background-color: rgba($--color-text-primary, 0.8);
  }
}

.run-line {
  position: absolute;
  z-index: 99;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  margin-top: 4px;
  margin-left: 5%;
  margin-right: 5%;
  font-size: 12px;
  color: $--color-text-secondary;
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-auto-columns: 1fr 1fr;
  grid-auto-flow: column;
  gap: 29px;
  h4 {
    display: flex;
    align-items: center;
    &:before {
      content: "●";
      font-size: 0.8em;
      margin: 0 4px;
    }
  }

  p {
    margin-top: 8px;
    padding: 0 12px;
    font-size: 18px;
    color: $--color-text-primary;
    small {
      font-size: 13px;
      color: $--color-text-secondary;
      margin-left: 4px;
    }
  }
  .line1 {
    // position: absolute;
    // top: 66px;
    // left: 0px;
    h4:before {
      color: $--color-primary;
    }
  }
  .line2 {
    // position: absolute;
    // top: 148px;
    // left: 0px;
    h4:before {
      color: $--color-warning;
    }
  }
  .line3 {
    // position: absolute;
    // top: 230px;
    // left: 0px;
    h4:before {
      color: $--color-success;
    }
  }
  .line4 {
    // position: absolute;
    // top: 66px;
    // right: 0px;
    h4:before {
      color: $--color-calm;
    }
  }
  .line5 {
    // position: absolute;
    // top: 148px;
    // right: 0px;
    h4:before {
      color: $--color-info;
    }
  }
  .line6 {
    // position: absolute;
    // top: 230px;
    // right: 0px;
    h4:before {
      color: $--color-black;
    }
  }
  .line4,
  .line5,
  .line6 {
    h4 {
      flex-direction: row-reverse;
    }
    p {
      text-align: right;
    }
  }
}

@media screen and (max-width: 1600px) {
  .run-line {
    margin-left: 2%;
    margin-right: 2%;
  }
}

@media screen and (max-width: 1800px) {
  .panel--gray {
    // /deep/ .panel-h {
    //   display: block;
    // }
    /deep/ .panel-tips {
      float: left;
      margin-left: 2.8em;
      line-height: 4;
      margin-top: -30px;
    }
  }
}
</style>
<style lang="scss">
.advert-pop-dialog {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  overflow: visible !important;
  border-radius: 0 !important;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0 !important;
    background: transparent !important;
    border: none !important;
    overflow: visible !important;
  }
}
.advert-pop-dialog .advert-pop-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.advert-pop-dialog .advert-pop-img {
  width: 100%;
  max-height: 70vh;
  object-fit: contain;
  cursor: pointer;
  display: block;
}
.advert-pop-dialog .advert-pop-close {
  margin-top: 12px;
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  font-size: 18px;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  cursor: pointer;
}
.advert-pop-dialog .advert-pop-close:hover {
  background: rgba(0, 0, 0, 0.7);
}
</style>
